// Matomo Tag Manager initialisieren (sofort, nicht dynamisch laden)
window._mtm = window._mtm || [];

// Page-Typ sofort setzen BEVOR MTM-Container lädt (verhindert pageTypeNotAvailable)
_mtm.push({ page: { name: 'Produktassistent', type: 'processPage', realm: 'natural-elements' } });

// Matomo Script dynamisch laden (falls noch nicht vorhanden)
(function() {
  if (!document.querySelector('script[src*="mtmloader"]')) {
    var script = document.createElement('script');
    script.setAttribute('data-realm', 'natural-elements');
    script.setAttribute('data-environment', 'dev');
    script.setAttribute('data-logging', 'on');
    script.src = 'https://neremor.homelinux.org/mtmloader/dev/latest.js';
    script.async = true;
    document.head.appendChild(script);
  }
})();

(function() {
const LOCALE = (() => {
  const locale = window._NE_LOCALE || document.documentElement.lang.split('-')[0].toLowerCase();
  if (locale === 'it' || locale === 'es') return locale;
  return 'de';
})();
const TRANSLATIONS = {
  de: {
    intro_eyebrow: 'Produktassistent · KI-gestützt',
    intro_headline: 'Finde, was <em>dein Körper</em><br>wirklich <span class="highlight">braucht.</span>',
    intro_subline: 'Keine generischen Empfehlungen. Chat Buddy, dein KI-Begleiter, hört zu, denkt mit, und baut dir einen Plan, der zu deinem Leben passt.',
    intro_feature1: 'Dauert maximal 90 Sekunden',
    intro_feature2: 'Passt sich deinen Zielen an',
    intro_feature3: 'Wissenschaftlich fundiert',
    intro_cta: 'Quiz starten',
    intro_disclaimer: '<strong>Bitte beachten:</strong> Wenn du schwanger bist, stillst oder Medikamente einnimmst, solltest du dich vor Verzehr fachlich beraten lassen. Diese Beratung ersetzt keine ärztliche Empfehlung.',
    q1_title: 'Was ist dein Hauptziel?',
    q1_energy: 'Mehr Energie im Alltag',
    q1_immune: 'Rundum gut versorgt fühlen',
    q1_beauty: 'Von innen strahlen',
    q1_sport: 'Besser trainieren',
    q1_sleep: 'Besser schlafen',
    q1_focus: 'Konzentrierter sein',
    q1_subline: 'Wähle den Bereich, den du gezielt ergänzen möchtest.',
    q2_title: 'Wie definierst du dich?',
    q2_female: 'Weiblich',
    q2_male: 'Männlich',
    q2_diverse: 'Divers',
    q2_none: 'Keine Angabe',
    q3_title: 'Wie alt bist du?',
    q3_18_35: '18–35 Jahre',
    q3_36_50: '36–50 Jahre',
    q3_51plus: '51+ Jahre',
    q4_title: 'Wie ernährst du dich?',
    q4_omni: 'Ausgewogen mit allem',
    q4_vegetarian: 'Vegetarisch',
    q4_vegan: 'Vegan',
    q4_lowfish: 'Wenig Fisch',
    q5_title: 'Wie sieht dein Alltag aus?',
    q5_desk: 'Hauptsächlich sitzend',
    q5_low: 'Wenig Bewegung',
    q5_active: 'Moderat aktiv (2-3x die Woche)',
    q5_athlete: 'Sehr aktiv (4x die Woche)',
    q5_stress: 'Viel Stress',
    analyzing_title: 'Dein Stack wird zusammengestellt …',
    analyzing_step1: 'Profil analysieren',
    analyzing_step2: 'Produkte abgleichen',
    analyzing_step3: 'Empfehlung erstellen',
    result_label: 'DEIN PERSÖNLICHER STACK',
    result_ai_label: 'CHAT BUDDY',
    result_ai_headline: 'Personalisiert für dich',
    bundle_title: 'Alle 3 bestellen & 10% sparen',
    bundle_blurb: 'Speziell für dich zusammengestellt. Du sparst gegenüber Einzelkauf.',
    einnahmeplan_label: 'DEIN EINNAHMEPLAN',
    morning: '☀️ Morgens',
    evening: '🌙 Abends',
    chat_label: 'Noch Fragen?',
    chat_headline: 'Geh tiefer mit<br>Chat Buddy.',
    chat_subline: 'Chat Buddy kennt dein Profil bereits. Du musst nichts wiederholen, frag ihn einfach was du noch wissen willst.',
    chat_placeholder: 'Stelle deine Frage an Chat Buddy …',
    chat_btn: 'Fragen',
    trust_1: 'In Deutschland entwickelt',
    trust_2: 'Ohne Zusatzstoffe',
    trust_3: 'Laborgeprüft',
    btn_next: 'Weiter',
    btn_add_to_cart: 'In den Warenkorb',
    toast_plan_sent: 'Plan wurde gesendet!',
    result_personal_plan: 'DEIN PERSÖNLICHER PLAN',
    quiz10_stackable: 'Spare zusätzlich 10% mit Code QUIZ10',
    quiz10_non_stackable: 'Dieses Produkt ist bereits reduziert. Der Code QUIZ10 ist nicht anwendbar.',
    chat_suggested_q: 'Warum passt dieser Stack zu mir?',
    cart_adding: 'Wird hinzugefügt...',
    cart_added: '✓ Hinzugefügt',
    cart_error: 'Fehler',
    bundle_btn_template: 'Alle {n} bestellen & 10% sparen',
    dosage_daily: 'täglich',
    dosage_evening: 'abends',
    dosage_after_training: 'nach dem Training',
    feature_1: 'Dauert maximal 90 Sekunden',
    feature_2: 'Personalisiert auf dich und deine Ziele',
    feature_3: 'Wissenschaftlich fundiert',
    q1_energy_sub: 'Energiestoffwechsel gezielt unterstützen',
    q1_immune_sub: 'Basis-Versorgung für das Immunsystem',
    q1_beauty_sub: 'Ergänzung für Haut, Haare & Nägel',
    q1_sport_sub: 'Rund um sportliche Belastung',
    q1_sleep_sub: 'Unterstützung für deine Abendroutine',
    q1_focus_sub: 'Unterstützung für Nervensystem & psychische Funktion',
    progress_label: 'Frage {n} von 5',
    buddy_notes: 'Chat Buddy notiert',
    analyzing_sub: 'Auswahl zusammenstellen…',
    analyzing_done: 'Auswahl steht!',
    ai_status: 'Personalisiert für dich',
    recap_title: 'Deine Angaben im Überblick',
    recap_goal: 'Ziel',
    recap_gender: 'Geschlecht',
    recap_age: 'Alter',
    recap_diet: 'Ernährung',
    recap_lifestyle: 'Alltag',
    bundle_eyebrow: 'Dein Perfect Match',
    bundle_badge: '★ Dein Perfect Match',
    bundle_perk_1: '10% Quiz-Rabatt',
    bundle_perk_2: 'Perfekt aufeinander abgestimmt',
    bundle_disclaimer: 'Code QUIZ10 nicht kombinierbar mit anderen Aktionen.',
    savings_prefix: 'DU SPARST',
    bundle_energy: 'Dein Energie-Set',
    bundle_immune: 'Dein Immunsystem-Set',
    bundle_beauty: 'Dein Beauty-Set',
    bundle_sport: 'Dein Trainings-Set',
    bundle_sleep: 'Dein Schlaf-Set',
    bundle_focus: 'Dein Fokus-Set',
    bundle_default: 'Dein persönlicher Stack',
    bundle_default_set: 'Dein Set',
    sub_vegan: 'Zusammengestellt für deine vegane Ernährungsweise',
    sub_vegetarian: 'Zusammengestellt für deine vegetarische Ernährungsweise',
    sub_51plus: 'Abgestimmt auf deine Lebensphase',
    sub_athlete: 'Zusammengestellt für dein Training',
    sub_stress: 'Zusammengestellt für deine Entspannungsroutine',
    sub_female_beauty: 'Abgestimmt für deine Beauty-Routine',
    sub_lowfish: 'Ergänzt mit Omega-3 Fettsäuren',
    sub_default: 'Aufeinander abgestimmt für dein Profil',
    restart_btn: 'Quiz erneut starten',
    btn_add: 'Hinzufügen',
    eyebrow_q1: 'DEIN ZIEL',
    eyebrow_q2: 'ÜBER DICH',
    eyebrow_q3: 'DEIN ALTER',
    eyebrow_q4: 'DEINE ERNÄHRUNG',
    eyebrow_q5: 'DEIN ALLTAG',
    q2_sub: 'Hilft uns, geschlechtsspezifische Nährstoffbedarfe zu berücksichtigen.',
    q3_sub: 'Hilft uns, passende Ergänzungen für deine Lebensphase auszuwählen.',
    q4_sub: 'Hilft uns, passende Ergänzungen für deine Ernährungsweise auszuwählen.',
    q5_sub: 'Hilft uns, passende Ergänzungen für deinen Lebensstil auszuwählen.',
    btn_back: 'Zurück',
    btn_back_start: 'Zurück zum Start',
    ai_intro: 'Basierend auf deinem Profil habe ich dir',
    ai_stack_energy: 'eine Auswahl für deinen Energiestoffwechsel zusammengestellt.',
    ai_stack_immune: 'eine Basis-Versorgung für dein Immunsystem zusammengestellt.',
    ai_stack_beauty: 'eine Auswahl für deine Beauty-Routine zusammengestellt.',
    ai_stack_sport: 'eine Auswahl für dein Training zusammengestellt.',
    ai_stack_sleep: 'eine Auswahl für deine Abendroutine zusammengestellt.',
    ai_stack_focus: 'eine Auswahl zur Unterstützung deiner Fokuszeit zusammengestellt.',
    ai_female_iron: 'Weil du weiblich angegeben hast, habe ich <b>Eisen</b> ergänzt. Das trägt zum normalen Energiestoffwechsel bei.',
    ai_vegan_intro: 'Für deine vegane Ernährung habe ich <b>B12</b> und <b>Omega-3 aus Algenöl</b> fest eingebaut.',
    ai_vegan_whey: 'Statt Whey-Protein, weil wir da keine Geschmackspräferenz einstellen können.',
    ai_vegan_why: 'B12 kommt natürlicherweise nicht in pflanzlicher Nahrung vor, EPA und DHA aus Algenöl tragen zur normalen Herzfunktion bei.',
    ai_vegetarian: 'Für deine vegetarische Ernährung habe ich tierische Produkte durch pflanzliche Alternativen ersetzt und <b>B12</b> ergänzt, das zum normalen Energiestoffwechsel beiträgt.',
    ai_lowfish: 'Weil du wenig Fisch isst, habe ich <b>Omega-3</b> ergänzt. EPA und DHA tragen zur normalen Herzfunktion bei.',
    ai_athlete: 'Bei deinem Trainingspensum passt <b>Kreatin</b> gut dazu. Es erhöht die körperliche Leistung bei kurzzeitiger intensiver Belastung.',
    ai_active_mag: 'Bei regelmäßigem Sport ist <b>Magnesium</b> besonders wertvoll, weil es zur normalen Muskelfunktion beiträgt.',
    ai_closing: 'Die drei Produkte sind aufeinander abgestimmt und passen gut in deine tägliche Routine.',
    analyzing_status1: 'Antworten verarbeiten',
    analyzing_status2: 'Passende Ergänzungen auswählen',
    analyzing_status3: 'Auf dein Profil abstimmen',
    analyzing_status4: 'Auswahl fertigstellen',
    ai_d3_energy: '<b>Vitamin D3/K2</b> trägt zur normalen Funktion des Immunsystems bei und bildet die Basis.',
    ai_mag_energy: '<b>Magnesium</b> unterstützt deinen Energiestoffwechsel und dein Nervensystem.',
    ai_bvitamins_energy: '<b>B-Vitamine</b> tragen zur Verringerung von Müdigkeit und Ermüdung bei.',
    ai_iron: '<b>Eisen</b> trägt zum normalen Energiestoffwechsel bei.',
    ai_b12: '<b>B12</b> trägt zum normalen Energiestoffwechsel bei.',
    ai_omega3: '<b>Omega-3</b> mit EPA und DHA tragen zur normalen Herzfunktion bei.',
    ai_d3_immune: '<b>Vitamin D3/K2</b> trägt zur normalen Funktion des Immunsystems bei und bildet die Grundlage.',
    ai_zinc_immune: '<b>Zink</b> unterstützt dein Immunsystem zusätzlich und schützt die Zellen vor oxidativem Stress.',
    ai_vitc_immune: '<b>Vitamin C</b> trägt ebenfalls zur normalen Funktion des Immunsystems bei.',
    ai_biotin_beauty: '<b>Biotin</b> trägt zur Erhaltung normaler Haut und Haare bei.',
    ai_hyaluron_beauty: 'Beim <b>Hyaluron-Kollagen-Komplex</b> sorgt das enthaltene Vitamin C für die normale Kollagenbildung der Haut.',
    ai_kreatin_sport: '<b>Kreatin</b> erhöht die körperliche Leistung bei kurzzeitiger intensiver Belastung.',
    ai_mag_sport: '<b>Magnesium</b> unterstützt deine Muskelfunktion und den Energiestoffwechsel.',
    ai_protein_sport: '<b>Eiweiß</b> trägt zu einer Zunahme und zum Erhalt von Muskelmasse bei.',
    ai_omega3_algenoel: '<b>Omega-3 aus Algenöl</b> liefert EPA und DHA, die zur normalen Herzfunktion beitragen.',
    ai_magbis_sleep: '<b>Magnesium Bisglycinat</b> unterstützt dein Nervensystem und trägt zur normalen psychischen Funktion bei.',
    ai_ashwa_sleep: '<b>Ashwagandha</b> ist eine traditionelle Pflanze aus der ayurvedischen Lehre und könnte eine hilfreiche Ergänzung sein.',
    ai_melatonin_sleep: '<b>Melatonin</b> trägt zur Verkürzung der Einschlafzeit bei (bei Aufnahme von 1 mg kurz vor dem Schlafengehen).',
    ai_ginkgo_focus: '<b>Ginkgo Biloba mit Vitamin B5 und Zink</b> bildet die Basis: Zink trägt zur normalen kognitiven Funktion bei, Vitamin B5 zum Energiestoffwechsel.',
    ai_bvitamins_focus: '<b>B-Vitamine</b> tragen zur normalen psychischen Funktion bei.',
    ai_magthreo_focus: '<b>Magnesium L-Threonat</b> trägt zur normalen Funktion des Nervensystems bei.',
    ai_magthreo_focus_p1: '<b>Magnesium L-Threonat</b> bildet die Basis und trägt zur normalen Funktion des Nervensystems bei.',
  },
  it: {
    intro_eyebrow: 'Assistente Prodotti · AI',
    intro_headline: 'Trova ciò di cui <em>il tuo corpo</em><br>ha <span class="highlight">veramente bisogno.</span>',
    intro_subline: 'Nessuna raccomandazione generica. Chat Buddy, il tuo assistente AI, ascolta, pensa con te e crea un piano adatto alla tua vita.',
    intro_feature1: 'Dura massimo 90 secondi',
    intro_feature2: 'Si adatta ai tuoi obiettivi',
    intro_feature3: 'Scientificamente fondato',
    intro_cta: 'Inizia il quiz',
    intro_disclaimer: '<strong>Nota bene:</strong> Se sei incinta, stai allattando o stai assumendo farmaci, dovresti consultare un professionista prima dell\'assunzione. Questa consulenza non sostituisce il parere medico.',
    q1_title: 'Qual è il tuo obiettivo principale?',
    q1_energy: 'Più energia quotidiana',
    q1_immune: 'Sentirsi completamente supportato',
    q1_beauty: 'Brillare dall\'interno',
    q1_sport: 'Allenarsi meglio',
    q1_sleep: 'Dormire meglio',
    q1_focus: 'Essere più concentrato',
    q1_subline: 'Scegli l\'area che vuoi integrare in modo mirato.',
    q2_title: 'Come ti definisci?',
    q2_female: 'Femminile',
    q2_male: 'Maschile',
    q2_diverse: 'Diverso',
    q2_none: 'Preferisco non specificare',
    q3_title: 'Quanti anni hai?',
    q3_18_35: '18–35 anni',
    q3_36_50: '36–50 anni',
    q3_51plus: '51+ anni',
    q4_title: 'Come ti nutri?',
    q4_omni: 'Dieta equilibrata con tutto',
    q4_vegetarian: 'Vegetariano',
    q4_vegan: 'Vegano',
    q4_lowfish: 'Poco pesce',
    q5_title: 'Com\'è la tua routine quotidiana?',
    q5_desk: 'Prevalentemente sedentario',
    q5_low: 'Poco movimento',
    q5_active: 'Moderatamente attivo (2-3x a settimana)',
    q5_athlete: 'Molto attivo (4x a settimana)',
    q5_stress: 'Molto stress',
    analyzing_title: 'Il tuo stack viene creato …',
    analyzing_step1: 'Analisi del profilo',
    analyzing_step2: 'Confronto prodotti',
    analyzing_step3: 'Creazione raccomandazione',
    result_label: 'IL TUO STACK PERSONALE',
    result_ai_label: 'CHAT BUDDY',
    result_ai_headline: 'Personalizzato per te',
    bundle_title: 'Ordina tutti e 3 e risparmia il 10%',
    bundle_blurb: 'Selezionato appositamente per te. Risparmi rispetto all\'acquisto singolo.',
    einnahmeplan_label: 'IL TUO PIANO DI ASSUNZIONE',
    morning: '☀️ Mattina',
    evening: '🌙 Sera',
    chat_label: 'Altre domande?',
    chat_headline: 'Approfondisci con<br>Chat Buddy.',
    chat_subline: 'Chat Buddy conosce già il tuo profilo. Non devi ripetere nulla, chiedigli quello che vuoi sapere.',
    chat_placeholder: 'Fai la tua domanda a Chat Buddy …',
    chat_btn: 'Chiedi',
    trust_1: 'Sviluppato in Germania',
    trust_2: 'Senza additivi',
    trust_3: 'Testato in laboratorio',
    btn_next: 'Avanti',
    btn_add_to_cart: 'Aggiungi al carrello',
    toast_plan_sent: 'Piano inviato!',
    result_personal_plan: 'IL TUO PIANO PERSONALE',
    quiz10_stackable: 'Usa il codice QUIZ10 per il 10% di sconto',
    quiz10_non_stackable: 'Questo prodotto è già in promozione. Il codice QUIZ10 non è applicabile.',
    chat_suggested_q: 'Perché questo stack è adatto a me?',
    cart_adding: 'Aggiunta in corso...',
    cart_added: '✓ Aggiunto',
    cart_error: 'Errore',
    bundle_btn_template: 'Ordina tutti {n} e risparmia il 10%',
    dosage_daily: 'al giorno',
    dosage_evening: 'di sera',
    dosage_after_training: 'dopo l\'allenamento',
    feature_1: 'Dura massimo 90 secondi',
    feature_2: 'Personalizzato sui tuoi obiettivi',
    feature_3: 'Scientificamente fondato',
    q1_energy_sub: 'Supporto mirato al metabolismo energetico',
    q1_immune_sub: 'Supporto base per il sistema immunitario',
    q1_beauty_sub: 'Integratori per pelle, capelli e unghie',
    q1_sport_sub: 'Per lo sforzo sportivo',
    q1_sleep_sub: 'Supporto per la tua routine serale',
    q1_focus_sub: 'Supporto per il sistema nervoso e la funzione psicologica',
    progress_label: 'Domanda {n} di 5',
    buddy_notes: 'Chat Buddy annota',
    analyzing_sub: 'Preparazione della selezione…',
    analyzing_done: 'Selezione pronta!',
    ai_status: 'Personalizzato per te',
    recap_title: 'Le tue risposte in sintesi',
    recap_goal: 'Obiettivo',
    recap_gender: 'Genere',
    recap_age: 'Età',
    recap_diet: 'Alimentazione',
    recap_lifestyle: 'Quotidianità',
    bundle_eyebrow: 'Il tuo Perfect Match',
    bundle_badge: '★ Il tuo Perfect Match',
    bundle_perk_1: '10% sconto quiz',
    bundle_perk_2: 'Perfettamente coordinati',
    bundle_disclaimer: 'Codice QUIZ10 non combinabile con altre promozioni.',
    savings_prefix: 'RISPARMI',
    bundle_energy: 'Il tuo Set Energia',
    bundle_immune: 'Il tuo Set Immunitario',
    bundle_beauty: 'Il tuo Set Beauty',
    bundle_sport: 'Il tuo Set Allenamento',
    bundle_sleep: 'Il tuo Set Sonno',
    bundle_focus: 'Il tuo Set Focus',
    bundle_default: 'Il tuo stack personale',
    bundle_default_set: 'Il tuo Set',
    sub_vegan: 'Selezionato per la tua alimentazione vegana',
    sub_vegetarian: 'Selezionato per la tua alimentazione vegetariana',
    sub_51plus: 'Adattato alla tua fase di vita',
    sub_athlete: 'Selezionato per il tuo allenamento',
    sub_stress: 'Selezionato per il tuo rilassamento',
    sub_female_beauty: 'Adattato per la tua routine beauty',
    sub_lowfish: 'Integrato con acidi grassi Omega-3',
    sub_default: 'Coordinato per il tuo profilo',
    restart_btn: 'Ricomincia il quiz',
    btn_add: 'Aggiungi',
    eyebrow_q1: 'IL TUO OBIETTIVO',
    eyebrow_q2: 'SU DI TE',
    eyebrow_q3: 'LA TUA ETÀ',
    eyebrow_q4: 'LA TUA ALIMENTAZIONE',
    eyebrow_q5: 'LA TUA QUOTIDIANITÀ',
    q2_sub: 'Ci aiuta a considerare i fabbisogni nutrizionali specifici per genere.',
    q3_sub: 'Ci aiuta a selezionare integratori adatti alla tua fase di vita.',
    q4_sub: 'Ci aiuta a selezionare integratori adatti alla tua alimentazione.',
    q5_sub: 'Ci aiuta a selezionare integratori adatti al tuo stile di vita.',
    btn_back: 'Indietro',
    btn_back_start: 'Torna all\'inizio',
    ai_intro: 'In base al tuo profilo, ho preparato',
    ai_stack_energy: 'una selezione per il tuo metabolismo energetico.',
    ai_stack_immune: 'un supporto base per il tuo sistema immunitario.',
    ai_stack_beauty: 'una selezione per la tua routine beauty.',
    ai_stack_sport: 'una selezione per il tuo allenamento.',
    ai_stack_sleep: 'una selezione per la tua routine serale.',
    ai_stack_focus: 'una selezione per supportare il tuo tempo di concentrazione.',
    ai_female_iron: 'Poiché hai indicato femminile, ho aggiunto <b>Ferro</b>. Contribuisce al normale metabolismo energetico.',
    ai_vegan_intro: 'Per la tua alimentazione vegana ho incluso fisso <b>B12</b> e <b>Omega-3 da olio di alghe</b>.',
    ai_vegan_whey: 'Invece di proteine Whey, perché non possiamo impostare preferenze di gusto.',
    ai_vegan_why: 'La B12 non si trova naturalmente negli alimenti vegetali, EPA e DHA da olio di alghe contribuiscono alla normale funzione cardiaca.',
    ai_vegetarian: 'Per la tua dieta vegetariana ho sostituito i prodotti animali con alternative vegetali e ho aggiunto <b>B12</b>, che contribuisce al normale metabolismo energetico.',
    ai_lowfish: 'Poiché mangi poco pesce, ho aggiunto <b>Omega-3</b>. EPA e DHA contribuiscono alla normale funzione cardiaca.',
    ai_athlete: 'Con il tuo ritmo di allenamento, la <b>Creatina</b> si adatta bene. Aumenta le prestazioni fisiche durante esercizi brevi e intensi.',
    ai_active_mag: 'Con sport regolare, il <b>Magnesio</b> è particolarmente prezioso perché contribuisce alla normale funzione muscolare.',
    ai_closing: 'I tre prodotti sono coordinati e si adattano bene alla tua routine quotidiana.',
    analyzing_status1: 'Elaborazione delle risposte',
    analyzing_status2: 'Selezione integrazioni adatte',
    analyzing_status3: 'Adattamento al tuo profilo',
    analyzing_status4: 'Finalizzazione selezione',
    ai_d3_energy: 'La <b>Vitamina D3/K2</b> contribuisce alla normale funzione del sistema immunitario e forma la base.',
    ai_mag_energy: 'Il <b>Magnesio</b> supporta il tuo metabolismo energetico e il tuo sistema nervoso.',
    ai_bvitamins_energy: 'Le <b>Vitamine B</b> contribuiscono alla riduzione della stanchezza e dell\'affaticamento.',
    ai_iron: 'Il <b>Ferro</b> contribuisce al normale metabolismo energetico.',
    ai_b12: 'La <b>B12</b> contribuisce al normale metabolismo energetico.',
    ai_omega3: '<b>Omega-3</b> con EPA e DHA contribuiscono alla normale funzione cardiaca.',
    ai_d3_immune: 'La <b>Vitamina D3/K2</b> contribuisce alla normale funzione del sistema immunitario e forma la base.',
    ai_zinc_immune: 'Lo <b>Zinco</b> supporta ulteriormente il tuo sistema immunitario e protegge le cellule dallo stress ossidativo.',
    ai_vitc_immune: 'La <b>Vitamina C</b> contribuisce anche alla normale funzione del sistema immunitario.',
    ai_biotin_beauty: 'La <b>Biotina</b> contribuisce al mantenimento di pelle e capelli normali.',
    ai_hyaluron_beauty: 'Nel <b>Complesso Acido Ialuronico-Collagene</b>, la vitamina C contenuta assicura la normale formazione di collagene della pelle.',
    ai_kreatin_sport: 'La <b>Creatina</b> aumenta le prestazioni fisiche durante esercizi brevi e intensi.',
    ai_mag_sport: 'Il <b>Magnesio</b> supporta la tua funzione muscolare e il metabolismo energetico.',
    ai_protein_sport: 'Le <b>Proteine</b> contribuiscono all\'aumento e al mantenimento della massa muscolare.',
    ai_omega3_algenoel: '<b>Omega-3 da olio di alghe</b> fornisce EPA e DHA, che contribuiscono alla normale funzione cardiaca.',
    ai_magbis_sleep: 'Il <b>Magnesio Bisglicinato</b> supporta il tuo sistema nervoso e contribuisce alla normale funzione psicologica.',
    ai_ashwa_sleep: '<b>Ashwagandha</b> è una pianta tradizionale della medicina ayurvedica e potrebbe essere un\'integrazione utile.',
    ai_melatonin_sleep: 'La <b>Melatonina</b> contribuisce alla riduzione del tempo necessario per addormentarsi (con l\'assunzione di 1 mg poco prima di andare a dormire).',
    ai_ginkgo_focus: '<b>Ginkgo Biloba con Vitamina B5 e Zinco</b> forma la base: lo zinco contribuisce alla normale funzione cognitiva, la vitamina B5 al metabolismo energetico.',
    ai_bvitamins_focus: 'Le <b>Vitamine B</b> contribuiscono alla normale funzione psicologica.',
    ai_magthreo_focus: 'Il <b>Magnesio L-Treonato</b> contribuisce alla normale funzione del sistema nervoso.',
    ai_magthreo_focus_p1: 'Il <b>Magnesio L-Treonato</b> forma la base e contribuisce alla normale funzione del sistema nervoso.',
  },
  es: {
    intro_eyebrow: 'Asistente de Productos · IA',
    intro_headline: 'Encuentra lo que <em>tu cuerpo</em><br>realmente <span class="highlight">necesita.</span>',
    intro_subline: 'Sin recomendaciones genéricas. Chat Buddy, tu asistente de IA, escucha, piensa contigo y crea un plan que se adapta a tu vida.',
    intro_feature1: 'Dura máximo 90 segundos',
    intro_feature2: 'Se adapta a tus objetivos',
    intro_feature3: 'Con base científica',
    intro_cta: 'Comenzar quiz',
    intro_disclaimer: '<strong>Ten en cuenta:</strong> Si estás embarazada, amamantando o tomando medicamentos, debes consultar con un profesional antes de consumir. Esta consulta no sustituye el consejo médico.',
    q1_title: '¿Cuál es tu objetivo principal?',
    q1_energy: 'Más energía diaria',
    q1_immune: 'Sentirse completamente apoyado',
    q1_beauty: 'Brillar desde dentro',
    q1_sport: 'Entrenar mejor',
    q1_sleep: 'Dormir mejor',
    q1_focus: 'Estar más concentrado',
    q1_subline: 'Elige el área que quieres complementar de forma específica.',
    q2_title: '¿Cómo te defines?',
    q2_female: 'Femenino',
    q2_male: 'Masculino',
    q2_diverse: 'Diverso',
    q2_none: 'Prefiero no especificar',
    q3_title: '¿Cuántos años tienes?',
    q3_18_35: '18–35 años',
    q3_36_50: '36–50 años',
    q3_51plus: '51+ años',
    q4_title: '¿Cómo te alimentas?',
    q4_omni: 'Dieta equilibrada con todo',
    q4_vegetarian: 'Vegetariano',
    q4_vegan: 'Vegano',
    q4_lowfish: 'Poco pescado',
    q5_title: '¿Cómo es tu día a día?',
    q5_desk: 'Principalmente sentado',
    q5_low: 'Poco movimiento',
    q5_active: 'Moderadamente activo (2-3x por semana)',
    q5_athlete: 'Muy activo (4x por semana)',
    q5_stress: 'Mucho estrés',
    analyzing_title: 'Tu stack se está creando …',
    analyzing_step1: 'Análisis de perfil',
    analyzing_step2: 'Comparación de productos',
    analyzing_step3: 'Creación de recomendación',
    result_label: 'TU STACK PERSONAL',
    result_ai_label: 'CHAT BUDDY',
    result_ai_headline: 'Personalizado para ti',
    bundle_title: 'Pide los 3 y ahorra 10%',
    bundle_blurb: 'Seleccionado especialmente para ti. Ahorras en comparación con la compra individual.',
    einnahmeplan_label: 'TU PLAN DE TOMA',
    morning: '☀️ Mañana',
    evening: '🌙 Noche',
    chat_label: '¿Más preguntas?',
    chat_headline: 'Profundiza con<br>Chat Buddy.',
    chat_subline: 'Chat Buddy ya conoce tu perfil. No tienes que repetir nada, pregúntale lo que quieras saber.',
    chat_placeholder: 'Haz tu pregunta a Chat Buddy …',
    chat_btn: 'Preguntar',
    trust_1: 'Desarrollado en Alemania',
    trust_2: 'Sin aditivos',
    trust_3: 'Probado en laboratorio',
    btn_next: 'Siguiente',
    btn_add_to_cart: 'Añadir al carrito',
    toast_plan_sent: '¡Plan enviado!',
    result_personal_plan: 'TU PLAN PERSONAL',
    quiz10_stackable: 'Usa el código QUIZ10 para un 10% de descuento',
    quiz10_non_stackable: 'Este producto ya está en promoción. El código QUIZ10 no es aplicable.',
    chat_suggested_q: '¿Por qué este stack es adecuado para mí?',
    cart_adding: 'Añadiendo...',
    cart_added: '✓ Añadido',
    cart_error: 'Error',
    bundle_btn_template: 'Pide los {n} y ahorra 10%',
    dosage_daily: 'al día',
    dosage_evening: 'por la noche',
    dosage_after_training: 'después del entrenamiento',
    feature_1: 'Dura máximo 90 segundos',
    feature_2: 'Personalizado según tus objetivos',
    feature_3: 'Con base científica',
    q1_energy_sub: 'Apoyo específico al metabolismo energético',
    q1_immune_sub: 'Apoyo base para el sistema inmunitario',
    q1_beauty_sub: 'Suplementos para piel, cabello y uñas',
    q1_sport_sub: 'Para el esfuerzo deportivo',
    q1_sleep_sub: 'Apoyo para tu rutina nocturna',
    q1_focus_sub: 'Apoyo para el sistema nervioso y la función psicológica',
    progress_label: 'Pregunta {n} de 5',
    buddy_notes: 'Chat Buddy anota',
    analyzing_sub: 'Preparando la selección…',
    analyzing_done: '¡Selección lista!',
    ai_status: 'Personalizado para ti',
    recap_title: 'Tus respuestas en resumen',
    recap_goal: 'Objetivo',
    recap_gender: 'Género',
    recap_age: 'Edad',
    recap_diet: 'Alimentación',
    recap_lifestyle: 'Día a día',
    bundle_eyebrow: 'Tu Perfect Match',
    bundle_badge: '★ Tu Perfect Match',
    bundle_perk_1: '10% descuento quiz',
    bundle_perk_2: 'Perfectamente coordinados',
    bundle_disclaimer: 'Código QUIZ10 no combinable con otras promociones.',
    savings_prefix: 'AHORRAS',
    bundle_energy: 'Tu Set Energía',
    bundle_immune: 'Tu Set Inmunitario',
    bundle_beauty: 'Tu Set Beauty',
    bundle_sport: 'Tu Set Entrenamiento',
    bundle_sleep: 'Tu Set Sueño',
    bundle_focus: 'Tu Set Concentración',
    bundle_default: 'Tu stack personal',
    bundle_default_set: 'Tu Set',
    sub_vegan: 'Seleccionado para tu alimentación vegana',
    sub_vegetarian: 'Seleccionado para tu alimentación vegetariana',
    sub_51plus: 'Adaptado a tu fase de vida',
    sub_athlete: 'Seleccionado para tu entrenamiento',
    sub_stress: 'Seleccionado para tu relajación',
    sub_female_beauty: 'Adaptado para tu rutina beauty',
    sub_lowfish: 'Complementado con ácidos grasos Omega-3',
    sub_default: 'Coordinado para tu perfil',
    restart_btn: 'Reiniciar el quiz',
    btn_add: 'Añadir',
    eyebrow_q1: 'TU OBJETIVO',
    eyebrow_q2: 'SOBRE TI',
    eyebrow_q3: 'TU EDAD',
    eyebrow_q4: 'TU ALIMENTACIÓN',
    eyebrow_q5: 'TU DÍA A DÍA',
    q2_sub: 'Nos ayuda a considerar las necesidades nutricionales específicas de género.',
    q3_sub: 'Nos ayuda a seleccionar suplementos adecuados para tu fase de vida.',
    q4_sub: 'Nos ayuda a seleccionar suplementos adecuados para tu alimentación.',
    q5_sub: 'Nos ayuda a seleccionar suplementos adecuados para tu estilo de vida.',
    btn_back: 'Atrás',
    btn_back_start: 'Volver al inicio',
    ai_intro: 'Basándome en tu perfil, he preparado',
    ai_stack_energy: 'una selección para tu metabolismo energético.',
    ai_stack_immune: 'un soporte base para tu sistema inmunitario.',
    ai_stack_beauty: 'una selección para tu rutina beauty.',
    ai_stack_sport: 'una selección para tu entrenamiento.',
    ai_stack_sleep: 'una selección para tu rutina nocturna.',
    ai_stack_focus: 'una selección para apoyar tu tiempo de concentración.',
    ai_female_iron: 'Como indicaste femenino, he añadido <b>Hierro</b>. Contribuye al metabolismo energético normal.',
    ai_vegan_intro: 'Para tu alimentación vegana he incluido fijo <b>B12</b> y <b>Omega-3 de aceite de algas</b>.',
    ai_vegan_whey: 'En lugar de proteína Whey, porque no podemos configurar preferencias de sabor.',
    ai_vegan_why: 'La B12 no se encuentra naturalmente en alimentos vegetales, EPA y DHA del aceite de algas contribuyen a la función cardíaca normal.',
    ai_vegetarian: 'Para tu dieta vegetariana he reemplazado productos animales con alternativas vegetales y he añadido <b>B12</b>, que contribuye al metabolismo energético normal.',
    ai_lowfish: 'Como comes poco pescado, he añadido <b>Omega-3</b>. EPA y DHA contribuyen a la función cardíaca normal.',
    ai_athlete: 'Con tu ritmo de entrenamiento, la <b>Creatina</b> encaja bien. Aumenta el rendimiento físico durante ejercicios breves e intensos.',
    ai_active_mag: 'Con deporte regular, el <b>Magnesio</b> es especialmente valioso porque contribuye a la función muscular normal.',
    ai_closing: 'Los tres productos están coordinados y encajan bien en tu rutina diaria.',
    analyzing_status1: 'Procesando respuestas',
    analyzing_status2: 'Seleccionando complementos adecuados',
    analyzing_status3: 'Adaptando a tu perfil',
    analyzing_status4: 'Finalizando selección',
    ai_d3_energy: 'La <b>Vitamina D3/K2</b> contribuye a la función normal del sistema inmunitario y forma la base.',
    ai_mag_energy: 'El <b>Magnesio</b> apoya tu metabolismo energético y tu sistema nervioso.',
    ai_bvitamins_energy: 'Las <b>Vitaminas B</b> contribuyen a la reducción del cansancio y la fatiga.',
    ai_iron: 'El <b>Hierro</b> contribuye al metabolismo energético normal.',
    ai_b12: 'La <b>B12</b> contribuye al metabolismo energético normal.',
    ai_omega3: '<b>Omega-3</b> con EPA y DHA contribuyen a la función cardíaca normal.',
    ai_d3_immune: 'La <b>Vitamina D3/K2</b> contribuye a la función normal del sistema inmunitario y forma la base.',
    ai_zinc_immune: 'El <b>Zinc</b> apoya adicionalmente tu sistema inmunitario y protege las células del estrés oxidativo.',
    ai_vitc_immune: 'La <b>Vitamina C</b> también contribuye a la función normal del sistema inmunitario.',
    ai_biotin_beauty: 'La <b>Biotina</b> contribuye al mantenimiento normal de la piel y el cabello.',
    ai_hyaluron_beauty: 'En el <b>Complejo Ácido Hialurónico-Colágeno</b>, la vitamina C contenida asegura la formación normal de colágeno de la piel.',
    ai_kreatin_sport: 'La <b>Creatina</b> aumenta el rendimiento físico durante ejercicios breves e intensos.',
    ai_mag_sport: 'El <b>Magnesio</b> apoya tu función muscular y el metabolismo energético.',
    ai_protein_sport: 'Las <b>Proteínas</b> contribuyen al aumento y mantenimiento de la masa muscular.',
    ai_omega3_algenoel: '<b>Omega-3 de aceite de algas</b> proporciona EPA y DHA, que contribuyen a la función cardíaca normal.',
    ai_magbis_sleep: 'El <b>Magnesio Bisglicinato</b> apoya tu sistema nervioso y contribuye a la función psicológica normal.',
    ai_ashwa_sleep: '<b>Ashwagandha</b> es una planta tradicional de la medicina ayurvédica y podría ser un complemento útil.',
    ai_melatonin_sleep: 'La <b>Melatonina</b> contribuye a disminuir el tiempo necesario para conciliar el sueño (con la toma de 1 mg poco antes de acostarse).',
    ai_ginkgo_focus: '<b>Ginkgo Biloba con Vitamina B5 y Zinc</b> forma la base: el zinc contribuye a la función cognitiva normal, la vitamina B5 al metabolismo energético.',
    ai_bvitamins_focus: 'Las <b>Vitaminas B</b> contribuyen a la función psicológica normal.',
    ai_magthreo_focus: 'El <b>Magnesio L-Treonato</b> contribuye a la función normal del sistema nervioso.',
    ai_magthreo_focus_p1: 'El <b>Magnesio L-Treonato</b> forma la base y contribuye a la función normal del sistema nervioso.',
  }
};
const t = TRANSLATIONS[LOCALE];
const NEProductText = {
  de: {
    d3k2_why: 'Vitamin D trägt zur normalen Funktion des Immunsystems bei', d3k2_dose: '1 Tropfen täglich',
    mag_why: 'Magnesium trägt zum normalen Energiestoffwechsel bei', mag_dose: '2 Kapseln täglich',
    bkomp_why: 'B2, B6, B12 tragen zur Verringerung von Müdigkeit bei', bkomp_dose: '1 Tablette täglich',
    zink_why: 'Zink trägt zur normalen Funktion des Immunsystems bei', zink_dose: '1 Tablette abends',
    vitc_why: 'Vitamin C trägt zur normalen Funktion des Immunsystems bei', vitc_dose: '1 Kapsel täglich',
    biotin_why: 'Biotin trägt zur Erhaltung normaler Haut bei', biotin_dose: '1 Tablette täglich',
    hyaluron_why: 'Vitamin C trägt zur normalen Kollagenbildung bei', hyaluron_dose: '1 Kapsel täglich',
    omega3_why: 'EPA und DHA tragen zur normalen Herzfunktion bei', omega3_dose: '2 Kapseln täglich',
    kreatin_why: 'Erhöht die körperliche Leistung bei Schnellkrafttraining', kreatin_dose: '3g täglich',
    mag_sport_why: 'Magnesium trägt zur normalen Muskelfunktion bei', mag_sport_dose: '2 Kapseln abends',
    protein_why: 'Protein trägt zum Erhalt der Muskelmasse bei', protein_dose: '30g nach dem Training',
    magbis_why: 'Magnesium trägt zur normalen psychischen Funktion bei', magbis_dose: '3 Kapseln abends',
    ashwa_why: 'Ashwagandha könnte eine hilfreiche Unterstützung sein', ashwa_dose: '2 Kapseln abends',
    mela_why: 'Melatonin trägt zur Verkürzung der Einschlafzeit bei (ab 1 mg)', mela_dose: '1 Tablette 30 Min vor dem Schlafen',
    ginkgo_why: 'Zink trägt zur normalen kognitiven Funktion bei', ginkgo_dose: '1 Kapsel täglich',
    bkomp_focus_why: 'B1, B6, B12 tragen zur normalen psychischen Funktion bei',
    magthreo_why: 'Magnesium trägt zur normalen Funktion des Nervensystems bei', magthreo_dose: '3 Kapseln täglich'
  },
  it: {
    d3k2_why: 'La vitamina D contribuisce alla normale funzione del sistema immunitario', d3k2_dose: '1 goccia al giorno',
    mag_why: 'Il magnesio contribuisce al normale metabolismo energetico', mag_dose: '2 capsule al giorno',
    bkomp_why: 'B2, B6, B12 contribuiscono alla riduzione della stanchezza', bkomp_dose: '1 compressa al giorno',
    zink_why: 'Lo zinco contribuisce alla normale funzione del sistema immunitario', zink_dose: '1 compressa di sera',
    vitc_why: 'La vitamina C contribuisce alla normale funzione del sistema immunitario', vitc_dose: '1 capsula al giorno',
    biotin_why: 'La biotina contribuisce al mantenimento di pelle normale', biotin_dose: '1 compressa al giorno',
    hyaluron_why: 'La vitamina C contribuisce alla normale formazione del collagene', hyaluron_dose: '1 capsula al giorno',
    omega3_why: 'EPA e DHA contribuiscono alla normale funzione cardiaca', omega3_dose: '2 capsule al giorno',
    kreatin_why: 'Aumenta le prestazioni fisiche durante esercizi brevi e intensi', kreatin_dose: '3g al giorno',
    mag_sport_why: 'Il magnesio contribuisce alla normale funzione muscolare', mag_sport_dose: '2 capsule di sera',
    protein_why: 'Le proteine contribuiscono al mantenimento della massa muscolare', protein_dose: '30g dopo l\'allenamento',
    magbis_why: 'Il magnesio contribuisce alla normale funzione psicologica', magbis_dose: '3 capsule di sera',
    ashwa_why: 'L\'Ashwagandha potrebbe essere un utile supporto', ashwa_dose: '2 capsule di sera',
    mela_why: 'La melatonina contribuisce alla riduzione del tempo necessario per addormentarsi (da 1 mg)', mela_dose: '1 compressa 30 min prima di dormire',
    ginkgo_why: 'Lo zinco contribuisce alla normale funzione cognitiva', ginkgo_dose: '1 capsula al giorno',
    bkomp_focus_why: 'B1, B6, B12 contribuiscono alla normale funzione psicologica',
    magthreo_why: 'Il magnesio contribuisce alla normale funzione del sistema nervoso', magthreo_dose: '3 capsule al giorno'
  },
  es: {
    d3k2_why: 'La vitamina D contribuye a la función normal del sistema inmunitario', d3k2_dose: '1 gota al día',
    mag_why: 'El magnesio contribuye al metabolismo energético normal', mag_dose: '2 cápsulas al día',
    bkomp_why: 'B2, B6, B12 contribuyen a la reducción del cansancio', bkomp_dose: '1 comprimido al día',
    zink_why: 'El zinc contribuye a la función normal del sistema inmunitario', zink_dose: '1 comprimido por la noche',
    vitc_why: 'La vitamina C contribuye a la función normal del sistema inmunitario', vitc_dose: '1 cápsula al día',
    biotin_why: 'La biotina contribuye al mantenimiento de la piel normal', biotin_dose: '1 comprimido al día',
    hyaluron_why: 'La vitamina C contribuye a la formación normal de colágeno', hyaluron_dose: '1 cápsula al día',
    omega3_why: 'EPA y DHA contribuyen a la función cardíaca normal', omega3_dose: '2 cápsulas al día',
    kreatin_why: 'Aumenta el rendimiento físico durante ejercicios breves e intensos', kreatin_dose: '3g al día',
    mag_sport_why: 'El magnesio contribuye a la función muscular normal', mag_sport_dose: '2 cápsulas por la noche',
    protein_why: 'La proteína contribuye al mantenimiento de la masa muscular', protein_dose: '30g después del entrenamiento',
    magbis_why: 'El magnesio contribuye a la función psicológica normal', magbis_dose: '3 cápsulas por la noche',
    ashwa_why: 'La Ashwagandha podría ser un apoyo útil', ashwa_dose: '2 cápsulas por la noche',
    mela_why: 'La melatonina contribuye a reducir el tiempo necesario para dormirse (desde 1 mg)', mela_dose: '1 comprimido 30 min antes de dormir',
    ginkgo_why: 'El zinc contribuye a la función cognitiva normal', ginkgo_dose: '1 cápsula al día',
    bkomp_focus_why: 'B1, B6, B12 contribuyen a la función psicológica normal',
    magthreo_why: 'El magnesio contribuye a la función normal del sistema nervioso', magthreo_dose: '3 cápsulas al día'
  }
};
const pt = NEProductText[LOCALE];
const NEProductFallbacks = {
  'vitamin-d3-k2-tropfen': { handle: 'vitamin-d3-k2-tropfen', title: 'Vitamin D3/K2 Tropfen', price: '€18,99', url: '/products/vitamin-d3-k2-tropfen', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/vitamin-d3-k2-tropfen-15232-02-packshot_b8e2f53f-b88f-4e4d-bfbf-33d4a4da8e2e.webp?v=1729683656' },
  'magnesium-komplex-kapseln': { handle: 'magnesium-komplex-kapseln', title: 'Magnesium Komplex Kapseln', price: '€24,99', url: '/products/magnesium-komplex-kapseln', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/magnesium-komplex-kapseln-15250-02-packshot_a35c3001-5bb5-42f2-bdab-01b08e6b8c2f.webp?v=1729683656' },
  'vitamin-b-komplex-tabletten': { handle: 'vitamin-b-komplex-tabletten', title: 'Vitamin B Komplex Tabletten', price: '€22,99', url: '/products/vitamin-b-komplex-tabletten', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/vitamin-b-komplex-tabletten-15204-02-packshot.webp?v=1729683656' },
  'zink-bisglycinat-tabletten-25mg': { handle: 'zink-bisglycinat-tabletten-25mg', title: 'Zink 25mg Tabletten', price: '€16,99', url: '/products/zink-bisglycinat-tabletten-25mg', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/zink-bisglycinat-tabletten-15202-02-packshot.webp?v=1729683656' },
  'vitamin-c-gepuffert-kapseln': { handle: 'vitamin-c-gepuffert-kapseln', title: 'Vitamin C Kapseln', price: '€19,99', url: '/products/vitamin-c-gepuffert-kapseln', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/vitamin-c-gepuffert-kapseln-15206-02-packshot.webp?v=1729683656' },
  'biotin-mit-selen-zink-tabletten': { handle: 'biotin-mit-selen-zink-tabletten', title: 'Biotin + Selen + Zink Tabletten', price: '€22,99', url: '/products/biotin-mit-selen-zink-tabletten', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/biotin-mit-selen-zink-tabletten-15216-02-packshot.webp?v=1729683656' },
  'hyaluron-kollagen-komplex-kapseln': { handle: 'hyaluron-kollagen-komplex-kapseln', title: 'Hyaluron Kollagen Komplex', price: '€29,99', url: '/products/hyaluron-kollagen-komplex-kapseln', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/hyaluron-kollagen-komplex-kapseln-15214-02-packshot.webp?v=1729683656' },
  'omega-3-fischol-kapseln': { handle: 'omega-3-fischol-kapseln', title: 'Omega 3 Fischöl Kapseln', price: '€29,99', url: '/products/omega-3-fischol-kapseln', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/omega-3-fischoel-kapseln-15258-01-packshotkachel_a_7f901866-2733-4506-b525-c962c48d3328-204608.webp?v=1729722733' },
  'kreatin-monohydrat-pulver': { handle: 'kreatin-monohydrat-pulver', title: 'Kreatin Monohydrat Pulver', price: '€16,99', url: '/products/kreatin-monohydrat-pulver', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/kreatin-monohydrat-pulver-15246-01-packshotkachel_c_97a3eeb1-d836-48f5-9ea1-e6e2508fa6f7-924801.webp?v=1732291287' },
  'soprotein-whey-complex': { handle: 'soprotein-whey-complex', title: 'SoProtein Whey Complex Schoko', price: '€33,99', url: '/products/soprotein-whey-complex', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/so-protein-whey-complex-chocolate-20513-01-packshotkachel.webp?v=1761616992' },
  'magnesiumbisglycinat-kapseln': { handle: 'magnesiumbisglycinat-kapseln', title: 'Magnesium Bisglycinat Kapseln', price: '€24,99', url: '/products/magnesiumbisglycinat-kapseln', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/magnesiumbisglycinat-kapseln-15252-02-packshot.webp?v=1729683656' },
  'bio-ashwagandha-ksm-66-kapseln': { handle: 'bio-ashwagandha-ksm-66-kapseln', title: 'Bio Ashwagandha (KSM-66) Kapseln', price: '€26,99', url: '/products/bio-ashwagandha-ksm-66-kapseln', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/bio-ashwagandha-kapseln-16476-02-packshot-830436.webp?v=1713366340' },
  'melatonin-tabletten': { handle: 'melatonin-tabletten', title: 'Melatonin Tabletten', price: '€14,99', url: '/products/melatonin-tabletten', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/melatonin-tabletten-15256-02-packshot.webp?v=1729683656' },
  'ginkgo-biloba-mit-vitamin-b5-zink-kapseln': { handle: 'ginkgo-biloba-mit-vitamin-b5-zink-kapseln', title: 'Ginkgo Biloba + B5 + Zink Kapseln', price: '€22,99', url: '/products/ginkgo-biloba-mit-vitamin-b5-zink-kapseln', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/ginkgo-biloba-mit-vitamin-b5-zink-kapseln-15240-02-packshot.webp?v=1729683656' },
  'magnesium-l-threonat-magtein': { handle: 'magnesium-l-threonat-magtein', title: 'Magnesium L-Threonat', price: '€29,99', url: '/products/magnesium-l-threonat-magtein', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/magnesium-l-threonat-magtein-20501-01-packshotkachel.webp?v=1729683656' },
  'gocce-di-vitamina-d3-k2': { handle: 'gocce-di-vitamina-d3-k2', title: 'Gocce di Vitamina D3/K2', price: '€18,99', url: '/products/gocce-di-vitamina-d3-k2', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/vitamin-d3-k2-tropfen-15232-02-packshot_b8e2f53f-b88f-4e4d-bfbf-33d4a4da8e2e.webp?v=1729683656' },
  'capsule-di-complesso-di-magnesio': { handle: 'capsule-di-complesso-di-magnesio', title: 'Capsule Complesso di Magnesio', price: '€24,99', url: '/products/capsule-di-complesso-di-magnesio', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/magnesium-komplex-kapseln-15250-02-packshot_a35c3001-5bb5-42f2-bdab-01b08e6b8c2f.webp?v=1729683656' },
  'compresse-di-complesso-vitaminico-b': { handle: 'compresse-di-complesso-vitaminico-b', title: 'Compresse Complesso Vitamina B', price: '€22,99', url: '/products/compresse-di-complesso-vitaminico-b', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/vitamin-b-komplex-tabletten-15204-02-packshot.webp?v=1729683656' },
  'compresse-di-zinco-bisglicinato-15mg': { handle: 'compresse-di-zinco-bisglicinato-15mg', title: 'Compresse Zinco 15mg', price: '€16,99', url: '/products/compresse-di-zinco-bisglicinato-15mg', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/zink-bisglycinat-tabletten-15202-02-packshot.webp?v=1729683656' },
  'vitamina-c-tamponata-capsule': { handle: 'vitamina-c-tamponata-capsule', title: 'Capsule Vitamina C Tamponata', price: '€19,99', url: '/products/vitamina-c-tamponata-capsule', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/vitamin-c-gepuffert-kapseln-15206-02-packshot.webp?v=1729683656' },
  'gummies-di-biotina-complessa': { handle: 'gummies-di-biotina-complessa', title: 'Gummies di Biotina Complessa', price: '€22,99', url: '/products/gummies-di-biotina-complessa', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/biotin-mit-selen-zink-tabletten-15216-02-packshot.webp?v=1729683656' },
  'capsule-di-acido-ialuronico': { handle: 'capsule-di-acido-ialuronico', title: 'Capsule di Acido Ialuronico', price: '€29,99', url: '/products/capsule-di-acido-ialuronico', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/hyaluron-kollagen-komplex-kapseln-15214-02-packshot.webp?v=1729683656' },
  'capsule-di-olio-di-pesce-omega-3': { handle: 'capsule-di-olio-di-pesce-omega-3', title: 'Capsule Olio di Pesce Omega 3', price: '€29,99', url: '/products/capsule-di-olio-di-pesce-omega-3', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/omega-3-fischoel-kapseln-15258-01-packshotkachel_a_7f901866-2733-4506-b525-c962c48d3328-204608.webp?v=1729722733' },
  'polvere-di-creatina-monoidrato-creapure': { handle: 'polvere-di-creatina-monoidrato-creapure', title: 'Polvere Creatina Monoidrato', price: '€16,99', url: '/products/polvere-di-creatina-monoidrato-creapure', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/kreatin-monohydrat-pulver-15246-01-packshotkachel_c_97a3eeb1-d836-48f5-9ea1-e6e2508fa6f7-924801.webp?v=1732291287' },
  'capsule-di-l-arginina': { handle: 'capsule-di-l-arginina', title: 'Capsule L-Arginina', price: '€33,99', url: '/products/capsule-di-l-arginina', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/so-protein-whey-complex-chocolate-20513-01-packshotkachel.webp?v=1761616992' },
  'capsule-di-magnesio-bisglicinato': { handle: 'capsule-di-magnesio-bisglicinato', title: 'Capsule Magnesio Bisglicinato', price: '€24,99', url: '/products/capsule-di-magnesio-bisglicinato', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/magnesiumbisglycinat-kapseln-15252-02-packshot.webp?v=1729683656' },
  'capsule-di-ashwagandha-biologico-ksm-66': { handle: 'capsule-di-ashwagandha-biologico-ksm-66', title: 'Capsule Ashwagandha Biologico (KSM-66)', price: '€26,99', url: '/products/capsule-di-ashwagandha-biologico-ksm-66', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/bio-ashwagandha-kapseln-16476-02-packshot-830436.webp?v=1713366340' },
  'compresse-di-melatonina': { handle: 'compresse-di-melatonina', title: 'Compresse Melatonina', price: '€14,99', url: '/products/compresse-di-melatonina', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/melatonin-tabletten-15256-02-packshot.webp?v=1729683656' },
  'gotas-de-vitamina-d3-k2': { handle: 'gotas-de-vitamina-d3-k2', title: 'Gotas de Vitamina D3/K2', price: '€18,99', url: '/products/gotas-de-vitamina-d3-k2', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/vitamin-d3-k2-tropfen-15232-02-packshot_b8e2f53f-b88f-4e4d-bfbf-33d4a4da8e2e.webp?v=1729683656' },
  'capsulas-de-complejo-de-magnesio': { handle: 'capsulas-de-complejo-de-magnesio', title: 'Cápsulas Complejo de Magnesio', price: '€24,99', url: '/products/capsulas-de-complejo-de-magnesio', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/magnesium-komplex-kapseln-15250-02-packshot_a35c3001-5bb5-42f2-bdab-01b08e6b8c2f.webp?v=1729683656' },
  'tabletas-complejo-de-vitamina-b': { handle: 'tabletas-complejo-de-vitamina-b', title: 'Tabletas Complejo Vitamina B', price: '€22,99', url: '/products/tabletas-complejo-de-vitamina-b', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/vitamin-b-komplex-tabletten-15204-02-packshot.webp?v=1729683656' },
  'tabletas-de-zinc-bisglicinato-15mg': { handle: 'tabletas-de-zinc-bisglicinato-15mg', title: 'Tabletas Zinc 15mg', price: '€16,99', url: '/products/tabletas-de-zinc-bisglicinato-15mg', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/zink-bisglycinat-tabletten-15202-02-packshot.webp?v=1729683656' },
  'capsulas-de-vitamina-c-tamponada': { handle: 'capsulas-de-vitamina-c-tamponada', title: 'Cápsulas Vitamina C Tamponada', price: '€19,99', url: '/products/capsulas-de-vitamina-c-tamponada', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/vitamin-c-gepuffert-kapseln-15206-02-packshot.webp?v=1729683656' },
  'tabletas-de-biotina-con-selenio-y-zinc': { handle: 'tabletas-de-biotina-con-selenio-y-zinc', title: 'Tabletas Biotina con Selenio y Zinc', price: '€22,99', url: '/products/tabletas-de-biotina-con-selenio-y-zinc', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/biotin-mit-selen-zink-tabletten-15216-02-packshot.webp?v=1729683656' },
  'capsulas-de-acido-hialuronico': { handle: 'capsulas-de-acido-hialuronico', title: 'Cápsulas Ácido Hialurónico', price: '€29,99', url: '/products/capsulas-de-acido-hialuronico', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/hyaluron-kollagen-komplex-kapseln-15214-02-packshot.webp?v=1729683656' },
  'capsulas-de-aceite-de-pescado-omega-3': { handle: 'capsulas-de-aceite-de-pescado-omega-3', title: 'Cápsulas Aceite de Pescado Omega 3', price: '€29,99', url: '/products/capsulas-de-aceite-de-pescado-omega-3', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/omega-3-fischoel-kapseln-15258-01-packshotkachel_a_7f901866-2733-4506-b525-c962c48d3328-204608.webp?v=1729722733' },
  'polvo-de-monohidrato-de-creatina-creapure': { handle: 'polvo-de-monohidrato-de-creatina-creapure', title: 'Polvo Creatina Monohidrato', price: '€16,99', url: '/products/polvo-de-monohidrato-de-creatina-creapure', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/kreatin-monohydrat-pulver-15246-01-packshotkachel_c_97a3eeb1-d836-48f5-9ea1-e6e2508fa6f7-924801.webp?v=1732291287' },
  'capsulas-de-l-arginina': { handle: 'capsulas-de-l-arginina', title: 'Cápsulas L-Arginina', price: '€33,99', url: '/products/capsulas-de-l-arginina', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/so-protein-whey-complex-chocolate-20513-01-packshotkachel.webp?v=1761616992' },
  'capsulas-de-magnesio-bisglicinato': { handle: 'capsulas-de-magnesio-bisglicinato', title: 'Cápsulas Magnesio Bisglicinato', price: '€24,99', url: '/products/capsulas-de-magnesio-bisglicinato', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/magnesiumbisglycinat-kapseln-15252-02-packshot.webp?v=1729683656' },
  'capsulas-de-ashwagandha-organico-ksm-66': { handle: 'capsulas-de-ashwagandha-organico-ksm-66', title: 'Cápsulas Ashwagandha Orgánico (KSM-66)', price: '€26,99', url: '/products/capsulas-de-ashwagandha-organico-ksm-66', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/bio-ashwagandha-kapseln-16476-02-packshot-830436.webp?v=1713366340' },
  'tabletas-de-melatonina': { handle: 'tabletas-de-melatonina', title: 'Tabletas Melatonina', price: '€14,99', url: '/products/tabletas-de-melatonina', image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/melatonin-tabletten-15256-02-packshot.webp?v=1729683656' }
};
const NEProductFallbackTitles = {
  de: {
    'vitamin-d3-k2-tropfen': 'Vitamin D3/K2 Tropfen',
    'magnesium-komplex-kapseln': 'Magnesium Komplex Kapseln',
    'vitamin-b-komplex-tabletten': 'Vitamin B Komplex Tabletten',
    'zink-bisglycinat-tabletten-25mg': 'Zink 25mg Tabletten',
    'vitamin-c-gepuffert-kapseln': 'Vitamin C Kapseln',
    'biotin-mit-selen-zink-tabletten': 'Biotin + Selen + Zink Tabletten',
    'hyaluron-kollagen-komplex-kapseln': 'Hyaluron Kollagen Komplex',
    'omega-3-fischol-kapseln': 'Omega 3 Fischöl Kapseln',
    'kreatin-monohydrat-pulver': 'Kreatin Monohydrat Pulver',
    'soprotein-whey-complex': 'SoProtein Whey Complex Schoko',
    'magnesiumbisglycinat-kapseln': 'Magnesium Bisglycinat Kapseln',
    'bio-ashwagandha-ksm-66-kapseln': 'Bio Ashwagandha (KSM-66) Kapseln',
    'melatonin-tabletten': 'Melatonin Tabletten',
    'ginkgo-biloba-mit-vitamin-b5-zink-kapseln': 'Ginkgo Biloba + B5 + Zink Kapseln',
    'magnesium-l-threonat-magtein': 'Magnesium L-Threonat'
  },
  it: {
    'vitamin-d3-k2-tropfen': 'Gocce di Vitamina D3/K2',
    'magnesium-komplex-kapseln': 'Capsule Complesso di Magnesio',
    'vitamin-b-komplex-tabletten': 'Compresse Complesso Vitamina B',
    'zink-bisglycinat-tabletten-25mg': 'Compresse Zinco 25mg',
    'vitamin-c-gepuffert-kapseln': 'Capsule Vitamina C',
    'biotin-mit-selen-zink-tabletten': 'Compresse Biotina + Selenio + Zinco',
    'hyaluron-kollagen-komplex-kapseln': 'Capsule Complesso Acido Ialuronico Collagene',
    'omega-3-fischol-kapseln': 'Capsule Olio di Pesce Omega 3',
    'kreatin-monohydrat-pulver': 'Polvere Creatina Monoidrato',
    'soprotein-whey-complex': 'SoProtein Whey Complex Cioccolato',
    'magnesiumbisglycinat-kapseln': 'Capsule Magnesio Bisglicinato',
    'bio-ashwagandha-ksm-66-kapseln': 'Capsule Ashwagandha Bio (KSM-66)',
    'melatonin-tabletten': 'Compresse Melatonina',
    'ginkgo-biloba-mit-vitamin-b5-zink-kapseln': 'Capsule Ginkgo Biloba + B5 + Zinco',
    'magnesium-l-threonat-magtein': 'Magnesio L-Treonato',
    'gocce-di-vitamina-d3-k2': 'Gocce di Vitamina D3/K2',
    'capsule-di-complesso-di-magnesio': 'Capsule Complesso di Magnesio',
    'compresse-di-complesso-vitaminico-b': 'Compresse Complesso Vitamina B',
    'compresse-di-zinco-bisglicinato-15mg': 'Compresse Zinco 15mg',
    'vitamina-c-tamponata-capsule': 'Capsule Vitamina C Tamponata',
    'gummies-di-biotina-complessa': 'Gummies di Biotina Complessa',
    'capsule-di-acido-ialuronico': 'Capsule di Acido Ialuronico',
    'capsule-di-olio-di-pesce-omega-3': 'Capsule Olio di Pesce Omega 3',
    'polvere-di-creatina-monoidrato-creapure': 'Polvere Creatina Monoidrato',
    'capsule-di-l-arginina': 'Capsule L-Arginina',
    'capsule-di-magnesio-bisglicinato': 'Capsule Magnesio Bisglicinato',
    'capsule-di-ashwagandha-biologico-ksm-66': 'Capsule Ashwagandha Biologico (KSM-66)',
    'compresse-di-melatonina': 'Compresse Melatonina'
  },
  es: {
    'vitamin-d3-k2-tropfen': 'Gotas de Vitamina D3/K2',
    'magnesium-komplex-kapseln': 'Cápsulas Complejo de Magnesio',
    'vitamin-b-komplex-tabletten': 'Comprimidos Complejo Vitamina B',
    'zink-bisglycinat-tabletten-25mg': 'Comprimidos Zinc 25mg',
    'vitamin-c-gepuffert-kapseln': 'Cápsulas Vitamina C',
    'biotin-mit-selen-zink-tabletten': 'Comprimidos Biotina + Selenio + Zinc',
    'hyaluron-kollagen-komplex-kapseln': 'Cápsulas Complejo Ácido Hialurónico Colágeno',
    'omega-3-fischol-kapseln': 'Cápsulas Aceite de Pescado Omega 3',
    'kreatin-monohydrat-pulver': 'Polvo Creatina Monohidrato',
    'soprotein-whey-complex': 'SoProtein Whey Complex Chocolate',
    'magnesiumbisglycinat-kapseln': 'Cápsulas Magnesio Bisglicinato',
    'bio-ashwagandha-ksm-66-kapseln': 'Cápsulas Ashwagandha Bio (KSM-66)',
    'melatonin-tabletten': 'Comprimidos Melatonina',
    'ginkgo-biloba-mit-vitamin-b5-zink-kapseln': 'Cápsulas Ginkgo Biloba + B5 + Zinc',
    'magnesium-l-threonat-magtein': 'Magnesio L-Treonato',
    'gotas-de-vitamina-d3-k2': 'Gotas de Vitamina D3/K2',
    'capsulas-de-complejo-de-magnesio': 'Cápsulas Complejo de Magnesio',
    'tabletas-complejo-de-vitamina-b': 'Tabletas Complejo Vitamina B',
    'tabletas-de-zinc-bisglicinato-15mg': 'Tabletas Zinc 15mg',
    'capsulas-de-vitamina-c-tamponada': 'Cápsulas Vitamina C Tamponada',
    'tabletas-de-biotina-con-selenio-y-zinc': 'Tabletas Biotina con Selenio y Zinc',
    'capsulas-de-acido-hialuronico': 'Cápsulas Ácido Hialurónico',
    'capsulas-de-aceite-de-pescado-omega-3': 'Cápsulas Aceite de Pescado Omega 3',
    'polvo-de-monohidrato-de-creatina-creapure': 'Polvo Creatina Monohidrato',
    'capsulas-de-l-arginina': 'Cápsulas L-Arginina',
    'capsulas-de-magnesio-bisglicinato': 'Cápsulas Magnesio Bisglicinato',
    'capsulas-de-ashwagandha-organico-ksm-66': 'Cápsulas Ashwagandha Orgánico (KSM-66)',
    'tabletas-de-melatonina': 'Tabletas Melatonina'
  }
};
const NEExtraProductTitles = {
  'vitamin-b12-tropfen': { de: 'Vitamin B12 Tropfen', it: 'Gocce di Vitamina B12', es: 'Gotas de Vitamina B12' },
  'gocce-di-vitamina-b12': { de: 'Vitamin B12 Tropfen', it: 'Gocce di Vitamina B12', es: 'Gotas de Vitamina B12' },
  'gotas-de-vitamina-b12': { de: 'Vitamin B12 Tropfen', it: 'Gocce di Vitamina B12', es: 'Gotas de Vitamina B12' },
  'eisen-mit-vitamin-c-tabletten': { de: 'Eisen mit Vitamin C Tabletten', it: 'Compresse Ferro con Vitamina C', es: 'Comprimidos Hierro con Vitamina C' },
  'capsule-di-ferro-con-vitamina-c': { de: 'Eisen mit Vitamin C Tabletten', it: 'Capsule di Ferro con Vitamina C', es: 'Cápsulas Hierro con Vitamina C' },
  'capsulas-de-hierro-con-vitamina-c': { de: 'Eisen mit Vitamin C Tabletten', it: 'Capsule Ferro con Vitamina C', es: 'Cápsulas de Hierro con Vitamina C' },
  'premium-omega-3-algenol': { de: 'Premium Omega 3 Algenöl', it: 'Olio di Alghe Omega 3 Premium', es: 'Aceite de Algas Omega 3 Premium' },
  'olio-di-alghe-omega-3-premium': { de: 'Premium Omega 3 Algenöl', it: 'Olio di Alghe Omega 3 Premium', es: 'Aceite de Algas Omega 3 Premium' },
  'aceite-de-algas-omega-3-premium': { de: 'Premium Omega 3 Algenöl', it: 'Olio di Alghe Omega 3 Premium', es: 'Aceite de Algas Omega 3 Premium' }
};
const NEExtraProducts = {
  b12: {
    handle: LOCALE === 'it' ? 'gocce-di-vitamina-b12' : LOCALE === 'es' ? 'gotas-de-vitamina-b12' : 'vitamin-b12-tropfen',
    title: (NEExtraProductTitles[LOCALE === 'it' ? 'gocce-di-vitamina-b12' : LOCALE === 'es' ? 'gotas-de-vitamina-b12' : 'vitamin-b12-tropfen'][LOCALE] || 'Vitamin B12 Tropfen'),
    price: '€19,99',
    url: LOCALE === 'it' ? '/products/gocce-di-vitamina-b12' : LOCALE === 'es' ? '/products/gotas-de-vitamina-b12' : '/products/vitamin-b12-tropfen',
    image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/vitamin-b12-tropfen-15234-02-packshot_ad6b3957-52fd-4df4-82a5-6398e18847da.webp?v=1729683660',
    why: { de:'B12 trägt zum normalen Energiestoffwechsel bei', it:'La B12 contribuisce al normale metabolismo energetico', es:'La B12 contribuye al metabolismo energético normal' }[LOCALE],
    dosage: { de:'1 Tropfen täglich', it:'1 goccia al giorno', es:'1 gota al día' }[LOCALE]
  },
  iron: {
    handle: LOCALE === 'it' ? 'capsule-di-ferro-con-vitamina-c' : LOCALE === 'es' ? 'capsulas-de-hierro-con-vitamina-c' : 'eisen-mit-vitamin-c-tabletten',
    title: (NEExtraProductTitles[LOCALE === 'it' ? 'capsule-di-ferro-con-vitamina-c' : LOCALE === 'es' ? 'capsulas-de-hierro-con-vitamina-c' : 'eisen-mit-vitamin-c-tabletten'][LOCALE] || 'Eisen mit Vitamin C Tabletten'),
    price: '€21,99',
    url: LOCALE === 'it' ? '/products/capsule-di-ferro-con-vitamina-c' : LOCALE === 'es' ? '/products/capsulas-de-hierro-con-vitamina-c' : '/products/eisen-mit-vitamin-c-tabletten',
    image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/eisen-mit-vitamin-c-tabletten-15210-02-packshot_c2889034-0e20-4130-9480-5588f484c214-373458.webp?v=1729722727',
    why: { de:'Eisen trägt zur Verringerung von Müdigkeit bei', it:'Il ferro contribuisce alla riduzione della stanchezza', es:'El hierro contribuye a la reducción del cansancio' }[LOCALE],
    dosage: { de:'1 Tablette täglich', it:'1 capsula al giorno', es:'1 cápsula al día' }[LOCALE]
  },
  algenoel: {
    handle: LOCALE === 'it' ? 'olio-di-alghe-omega-3-premium' : LOCALE === 'es' ? 'aceite-de-algas-omega-3-premium' : 'premium-omega-3-algenol',
    title: (NEExtraProductTitles[LOCALE === 'it' ? 'olio-di-alghe-omega-3-premium' : LOCALE === 'es' ? 'aceite-de-algas-omega-3-premium' : 'premium-omega-3-algenol'][LOCALE] || 'Premium Omega 3 Algenöl'),
    price: '€33,99',
    url: LOCALE === 'it' ? '/products/olio-di-alghe-omega-3-premium' : LOCALE === 'es' ? '/products/aceite-de-algas-omega-3-premium' : '/products/premium-omega-3-algenol',
    image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/ne_omega3_algenoel-01-packshotkachel_1f422f16-c2a3-4908-87c8-1a3572b1a3da-327112.webp?v=1731628443',
    why: pt.omega3_why,
    dosage: pt.omega3_dose
  },
  protein: {
    handle: LOCALE === 'it' ? 'capsule-di-l-arginina' : LOCALE === 'es' ? 'capsulas-de-l-arginina' : 'soprotein-whey-complex',
    title: (NEProductFallbackTitles[LOCALE] && NEProductFallbackTitles[LOCALE][LOCALE === 'it' ? 'capsule-di-l-arginina' : LOCALE === 'es' ? 'capsulas-de-l-arginina' : 'soprotein-whey-complex']) || 'SoProtein Whey Complex Schoko',
    price: '€33,99',
    url: LOCALE === 'it' ? '/products/capsule-di-l-arginina' : LOCALE === 'es' ? '/products/capsulas-de-l-arginina' : '/products/soprotein-whey-complex',
    image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/so-protein-whey-complex-chocolate-20513-01-packshotkachel.webp?v=1761616992',
    why: pt.protein_why, dosage: pt.protein_dose
  },
  omega3: {
    handle: LOCALE === 'it' ? 'capsule-di-olio-di-pesce-omega-3' : LOCALE === 'es' ? 'capsulas-de-aceite-de-pescado-omega-3' : 'omega-3-fischol-kapseln',
    title: (NEProductFallbackTitles[LOCALE] && NEProductFallbackTitles[LOCALE][LOCALE === 'it' ? 'capsule-di-olio-di-pesce-omega-3' : LOCALE === 'es' ? 'capsulas-de-aceite-de-pescado-omega-3' : 'omega-3-fischol-kapseln']) || 'Omega 3 Fischöl Kapseln',
    price: '€29,99',
    url: LOCALE === 'it' ? '/products/capsule-di-olio-di-pesce-omega-3' : LOCALE === 'es' ? '/products/capsulas-de-aceite-de-pescado-omega-3' : '/products/omega-3-fischol-kapseln',
    image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/omega-3-fischoel-kapseln-15258-01-packshotkachel_a_7f901866-2733-4506-b525-c962c48d3328-204608.webp?v=1729722733',
    why: pt.omega3_why, dosage: pt.omega3_dose
  },
  kreatin: {
    handle: LOCALE === 'it' ? 'polvere-di-creatina-monoidrato-creapure' : LOCALE === 'es' ? 'polvo-de-monohidrato-de-creatina-creapure' : 'kreatin-monohydrat-pulver',
    title: (NEProductFallbackTitles[LOCALE] && NEProductFallbackTitles[LOCALE][LOCALE === 'it' ? 'polvere-di-creatina-monoidrato-creapure' : LOCALE === 'es' ? 'polvo-de-monohidrato-de-creatina-creapure' : 'kreatin-monohydrat-pulver']) || 'Kreatin Monohydrat Pulver',
    price: '€16,99',
    url: LOCALE === 'it' ? '/products/polvere-di-creatina-monoidrato-creapure' : LOCALE === 'es' ? '/products/polvo-de-monohidrato-de-creatina-creapure' : '/products/kreatin-monohydrat-pulver',
    image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/kreatin-monohydrat-pulver-15246-01-packshotkachel_c_97a3eeb1-d836-48f5-9ea1-e6e2508fa6f7-924801.webp?v=1732291287',
    why: pt.kreatin_why, dosage: pt.kreatin_dose
  },
  ashwagandha: {
    handle: LOCALE === 'it' ? 'capsule-di-ashwagandha-biologico-ksm-66' : LOCALE === 'es' ? 'capsulas-de-ashwagandha-organico-ksm-66' : 'bio-ashwagandha-ksm-66-kapseln',
    title: (NEProductFallbackTitles[LOCALE] && NEProductFallbackTitles[LOCALE][LOCALE === 'it' ? 'capsule-di-ashwagandha-biologico-ksm-66' : LOCALE === 'es' ? 'capsulas-de-ashwagandha-organico-ksm-66' : 'bio-ashwagandha-ksm-66-kapseln']) || 'Bio Ashwagandha (KSM-66) Kapseln',
    price: '€26,99',
    url: LOCALE === 'it' ? '/products/capsule-di-ashwagandha-biologico-ksm-66' : LOCALE === 'es' ? '/products/capsulas-de-ashwagandha-organico-ksm-66' : '/products/bio-ashwagandha-ksm-66-kapseln',
    image: 'https://cdn.shopify.com/s/files/1/0794/6292/4625/files/bio-ashwagandha-kapseln-16476-02-packshot-830436.webp?v=1713366340',
    why: pt.ashwa_why, dosage: pt.ashwa_dose
  }
};
const NEPriceOverrides = {
  it: {
    'gocce-di-vitamina-d3-k2': '€18,69',
    'capsule-di-complesso-di-magnesio': '€17,24',
    'compresse-di-complesso-vitaminico-b': '€12,74',
    'compresse-di-zinco-bisglicinato-15mg': '€9,79',
    'vitamina-c-tamponata-capsule': '€16,57',
    'gummies-di-biotina-complessa': '€16,99',
    'capsule-di-acido-ialuronico': '€16,99',
    'capsule-di-olio-di-pesce-omega-3': '€25,49',
    'capsule-di-l-arginina': '€23,39',
    'capsule-di-magnesio-bisglicinato': '€14,99',
    'compresse-di-melatonina': '€9,44',
    'gocce-di-vitamina-b12': '€17,59',
    'capsule-di-ferro-con-vitamina-c': '€15,74',
    'olio-di-alghe-omega-3-premium': '€26,51',
    'magnesium-l-threonat-magtein': '€26,99'
  },
  es: {
    'gotas-de-vitamina-d3-k2': '€17,99',
    'capsulas-de-complejo-de-magnesio': '€14,99',
    'tabletas-complejo-de-vitamina-b': '€12,74',
    'capsulas-de-hierro-con-vitamina-c': '€14,39',
    'tabletas-de-zinc-bisglicinato-15mg': '€9,74',
    'capsulas-de-vitamina-c-tamponada': '€19,99',
    'capsulas-de-magnesio-bisglicinato': '€14,99',
    'gotas-de-vitamina-b12': '€13,59',
    'tabletas-de-melatonina': '€8,99',
    'capsulas-de-aceite-de-pescado-omega-3': '€24,79',
    'tabletas-de-biotina-con-selenio-y-zinc': '€9,59',
    'capsulas-de-l-arginina': '€22,79'
  }
};
function lp(liquidProduct, handle, why, dosage) {
  if (liquidProduct) {
    const priceOverride = NEPriceOverrides[LOCALE] && NEPriceOverrides[LOCALE][liquidProduct.handle];
    const price = priceOverride || liquidProduct.price;
    const compareAtPrice = liquidProduct.compareAtPrice || null;
    return { handle: liquidProduct.handle, title: liquidProduct.title, price: price, compareAtPrice: compareAtPrice, url: liquidProduct.url, image: liquidProduct.image, why: why, dosage: dosage };
  }
  const fb = NEProductFallbacks[handle];
  if (fb) {
    const localizedTitle = (NEProductFallbackTitles[LOCALE] && NEProductFallbackTitles[LOCALE][handle]) || fb.title;
    const priceOverride = NEPriceOverrides[LOCALE] && NEPriceOverrides[LOCALE][handle];
    const price = priceOverride || fb.price;
    return { ...fb, title: localizedTitle, price: price, compareAtPrice: null, why: why, dosage: dosage };
  }
  return null;
}
const rp = window._NE_RAW_PRODUCTS || {};
const NEQuizProducts = {
  energy: [
    lp(rp.energy_p1, LOCALE === 'it' ? 'gocce-di-vitamina-d3-k2' : LOCALE === 'es' ? 'gotas-de-vitamina-d3-k2' : 'vitamin-d3-k2-tropfen', pt.d3k2_why, pt.d3k2_dose),
    lp(rp.energy_p2, LOCALE === 'it' ? 'capsule-di-complesso-di-magnesio' : LOCALE === 'es' ? 'capsulas-de-complejo-de-magnesio' : 'magnesium-komplex-kapseln', pt.mag_why, pt.mag_dose),
    lp(rp.energy_p3, LOCALE === 'it' ? 'compresse-di-complesso-vitaminico-b' : LOCALE === 'es' ? 'tabletas-complejo-de-vitamina-b' : 'vitamin-b-komplex-tabletten', pt.bkomp_why, pt.bkomp_dose)
  ].filter(Boolean),
  immune: [
    lp(rp.immune_p1, LOCALE === 'it' ? 'gocce-di-vitamina-d3-k2' : LOCALE === 'es' ? 'gotas-de-vitamina-d3-k2' : 'vitamin-d3-k2-tropfen', pt.d3k2_why, pt.d3k2_dose),
    lp(rp.immune_p2, LOCALE === 'it' ? 'compresse-di-zinco-bisglicinato-15mg' : LOCALE === 'es' ? 'tabletas-de-zinc-bisglicinato-15mg' : 'zink-bisglycinat-tabletten-25mg', pt.zink_why, pt.zink_dose),
    lp(rp.immune_p3, LOCALE === 'it' ? 'vitamina-c-tamponata-capsule' : LOCALE === 'es' ? 'capsulas-de-vitamina-c-tamponada' : 'vitamin-c-gepuffert-kapseln', pt.vitc_why, pt.vitc_dose)
  ].filter(Boolean),
  beauty: [
    lp(rp.beauty_p1, LOCALE === 'it' ? 'gummies-di-biotina-complessa' : LOCALE === 'es' ? 'tabletas-de-biotina-con-selenio-y-zinc' : 'biotin-mit-selen-zink-tabletten', pt.biotin_why, pt.biotin_dose),
    lp(rp.beauty_p2, LOCALE === 'it' ? 'capsule-di-acido-ialuronico' : LOCALE === 'es' ? 'capsulas-de-acido-hialuronico' : 'hyaluron-kollagen-komplex-kapseln', pt.hyaluron_why, pt.hyaluron_dose),
    lp(rp.beauty_p3, LOCALE === 'it' ? 'capsule-di-olio-di-pesce-omega-3' : LOCALE === 'es' ? 'capsulas-de-aceite-de-pescado-omega-3' : 'omega-3-fischol-kapseln', pt.omega3_why, pt.omega3_dose)
  ].filter(Boolean),
  sport: [
    lp(rp.sport_p1, LOCALE === 'it' ? 'polvere-di-creatina-monoidrato-creapure' : LOCALE === 'es' ? 'polvo-de-monohidrato-de-creatina-creapure' : 'kreatin-monohydrat-pulver', pt.kreatin_why, pt.kreatin_dose),
    lp(rp.sport_p2, LOCALE === 'it' ? 'capsule-di-complesso-di-magnesio' : LOCALE === 'es' ? 'capsulas-de-complejo-de-magnesio' : 'magnesium-komplex-kapseln', pt.mag_sport_why, pt.mag_sport_dose),
    lp(rp.sport_p3, LOCALE === 'it' ? 'capsule-di-l-arginina' : LOCALE === 'es' ? 'capsulas-de-l-arginina' : 'soprotein-whey-complex', pt.protein_why, pt.protein_dose)
  ].filter(Boolean),
  sleep: [
    lp(rp.sleep_p1, LOCALE === 'it' ? 'capsule-di-magnesio-bisglicinato' : LOCALE === 'es' ? 'capsulas-de-magnesio-bisglicinato' : 'magnesiumbisglycinat-kapseln', pt.magbis_why, pt.magbis_dose),
    lp(rp.sleep_p2, LOCALE === 'it' ? 'capsule-di-ashwagandha-biologico-ksm-66' : LOCALE === 'es' ? 'capsulas-de-ashwagandha-organico-ksm-66' : 'bio-ashwagandha-ksm-66-kapseln', pt.ashwa_why, pt.ashwa_dose),
    lp(rp.sleep_p3, LOCALE === 'it' ? 'compresse-di-melatonina' : LOCALE === 'es' ? 'tabletas-de-melatonina' : 'melatonin-tabletten', pt.mela_why, pt.mela_dose)
  ].filter(Boolean),
  focus: [
    lp(rp.focus_p1, LOCALE === 'it' ? 'magnesium-l-threonat-magtein' : LOCALE === 'es' ? 'magnesium-l-threonat-magtein' : 'ginkgo-biloba-mit-vitamin-b5-zink-kapseln', pt.ginkgo_why, pt.ginkgo_dose),
    lp(rp.focus_p2, LOCALE === 'it' ? 'compresse-di-complesso-vitaminico-b' : LOCALE === 'es' ? 'tabletas-complejo-de-vitamina-b' : 'vitamin-b-komplex-tabletten', pt.bkomp_focus_why, pt.bkomp_dose),
    lp(rp.focus_p3, LOCALE === 'it' ? 'capsule-di-complesso-di-magnesio' : LOCALE === 'es' ? 'capsulas-de-complejo-de-magnesio' : 'magnesium-l-threonat-magtein', pt.magthreo_why, pt.magthreo_dose)
  ].filter(Boolean)
};
const NEQuizMeta = (() => {
  const meta = {
    de: {
      energy: {
        title: 'Energie-Unterstützung',
        description: 'Aufeinander abgestimmte Mikronährstoffe für deinen Energiestoffwechsel.',
        tags: ['Energie', 'B-Vitamine', 'Magnesium']
      },
      immune: {
        title: 'Basis-Versorgung',
        description: 'Drei aufeinander abgestimmte Produkte zur Unterstützung deines Immunsystems.',
        tags: ['Immunsystem', 'Vitamine', 'Mikronährstoffe']
      },
      beauty: {
        title: 'Beauty-Routine',
        description: 'Abgestimmt für deine Beauty-Routine. Biotin trägt zur Erhaltung normaler Haut bei.',
        tags: ['Beauty', 'Biotin', 'Kollagen']
      },
      sport: {
        title: 'Trainings-Support',
        description: 'Für Training, Performance und Muskelaufbau zusammengestellt.',
        tags: ['Sport', 'Kreatin', 'Protein']
      },
      sleep: {
        title: 'Schlaf-Routine',
        description: 'Aufeinander abgestimmt für deine Abendroutine.',
        tags: ['Schlaf', 'Entspannung', 'Magnesium']
      },
      focus: {
        title: 'Fokus-Unterstützung',
        description: 'Unterstützung für deine Fokuszeit. B1, B6, B12 tragen zur normalen psychischen Funktion bei.',
        tags: ['Fokus', 'Nervensystem', 'B-Vitamine']
      }
    },
    it: {
      energy: {
        title: 'Supporto Energetico',
        description: 'Micronutrienti coordinati per il tuo metabolismo energetico.',
        tags: ['Energia', 'Vitamine B', 'Magnesio']
      },
      immune: {
        title: 'Supporto Base',
        description: 'Tre prodotti coordinati per supportare il tuo sistema immunitario.',
        tags: ['Sistema immunitario', 'Vitamine', 'Micronutrienti']
      },
      beauty: {
        title: 'Routine Beauty',
        description: 'Coordinato per la tua routine beauty. La biotina contribuisce al mantenimento di pelle normale.',
        tags: ['Beauty', 'Biotina', 'Collagene']
      },
      sport: {
        title: 'Supporto Allenamento',
        description: 'Assemblato per allenamento, prestazioni e crescita muscolare.',
        tags: ['Sport', 'Creatina', 'Proteine']
      },
      sleep: {
        title: 'Routine Sonno',
        description: 'Coordinato per la tua routine serale.',
        tags: ['Sonno', 'Rilassamento', 'Magnesio']
      },
      focus: {
        title: 'Supporto Focus',
        description: 'Supporto per il tuo tempo di concentrazione. B1, B6, B12 contribuiscono alla funzione psicologica normale.',
        tags: ['Focus', 'Sistema nervoso', 'Vitamine B']
      }
    },
    es: {
      energy: {
        title: 'Soporte Energético',
        description: 'Micronutrientes coordinados para tu metabolismo energético.',
        tags: ['Energía', 'Vitaminas B', 'Magnesio']
      },
      immune: {
        title: 'Soporte Base',
        description: 'Tres productos coordinados para apoyar tu sistema inmunitario.',
        tags: ['Sistema inmunitario', 'Vitaminas', 'Micronutrientes']
      },
      beauty: {
        title: 'Rutina Beauty',
        description: 'Coordinado para tu rutina beauty. La biotina contribuye al mantenimiento de la piel normal.',
        tags: ['Beauty', 'Biotina', 'Colágeno']
      },
      sport: {
        title: 'Soporte Entrenamiento',
        description: 'Ensamblado para entrenamiento, rendimiento y crecimiento muscular.',
        tags: ['Deporte', 'Creatina', 'Proteína']
      },
      sleep: {
        title: 'Rutina Sueño',
        description: 'Coordinado para tu rutina nocturna.',
        tags: ['Sueño', 'Relajación', 'Magnesio']
      },
      focus: {
        title: 'Soporte Concentración',
        description: 'Soporte para tu tiempo de concentración. B1, B6, B12 contribuyen a la función psicológica normal.',
        tags: ['Concentración', 'Sistema nervioso', 'Vitaminas B']
      }
    }
  };
  return meta[LOCALE];
})();
const NEQuizInsights = (() => {
  const insights = {
    de: {
      q1: {
        energy: "Alles klar, Energiestoffwechsel! Da schaue ich mir vor allem B-Vitamine an, die tragen zu einem normalen Energiestoffwechsel bei. Mal sehen, was noch dazu passt.",
        immune: "Immunsystem, verstanden. Vitamin D, Zink und Vitamin C tragen alle zur normalen Funktion des Immunsystems bei. Da stelle ich dir was Gutes zusammen.",
        beauty: "Beauty, schönes Thema! Biotin trägt zur Erhaltung normaler Haut und Haare bei. Schaue ich mir genauer an für dich.",
        sport: "Training, passt! Eiweiß trägt zum Erhalt der Muskelmasse bei und Magnesium zum normalen Energiestoffwechsel. Da habe ich ein paar gute Sachen.",
        sleep: "Schlaf-Support, alles klar. Magnesium trägt zur normalen Funktion des Nervensystems bei. Gute Basis für deine Abendroutine!",
        focus: "Fokus, verstanden! B1, B6 und B12 tragen zur normalen psychischen Funktion bei und Magnesium zur normalen Funktion des Nervensystems. Da lässt sich was machen."
      },
      q2: {
        female: "Gut zu wissen! Bei Frauen kann Eisen je nach Bereich eine sinnvolle Ergänzung sein. Baue ich ggf. mit ein.",
        male: "Alles klar, berücksichtige ich bei der Auswahl.",
        diverse: "Verstanden, ich orientiere mich an deinen anderen Antworten.",
        none: "Kein Problem, ich orientiere mich an deinen anderen Antworten."
      },
      q3: {
        '18-35': "Perfekt! In dieser Lebensphase ist eine gute Basis-Versorgung oft der Schlüssel. Schaue ich mir an!",
        '36-50': "Gut zu wissen. Ab Mitte 30 kann eine gezielte Mikronährstoff-Versorgung eine sinnvolle Unterstützung sein.",
        '51+': "Alles klar! In dieser Lebensphase ist der Erhalt der Muskelmasse wichtig. Eiweiß trägt genau dazu bei, berücksichtige ich."
      },
      q4: {
        omni: "Super, ausgewogene Ernährung ist schon mal eine gute Basis! Trotzdem kann eine gezielte Ergänzung sinnvoll sein.",
        vegetarian: "Vegetarisch, alles klar. Tierische Produkte ersetze ich durch pflanzliche Alternativen und B12 ergänze ich, falls nötig.",
        vegan: "Vegan, verstanden! B12 und Omega-3 aus Algenöl baue ich fest in deinen Stack ein, denn beides kommt nicht in pflanzlicher Nahrung vor.",
        lowfish: "Alles klar. EPA und DHA aus Omega-3 tragen zur normalen Herzfunktion bei, das nehme ich mit auf."
      },
      q5: {
        desk: "Hauptsächlich sitzend, verstehe. Vitamin D trägt zur normalen Funktion des Immunsystems bei, das berücksichtige ich.",
        low: "Wenig Bewegung, alles klar. Da achte ich besonders auf eine gute Basis-Versorgung für dich.",
        active: "Schön, dass du aktiv bist! Magnesium trägt zur normalen Muskelfunktion bei, das fließt mit ein.",
        athlete: "Stark, 4x+ pro Woche! Kreatin erhöht die körperliche Leistung bei kurzzeitiger intensiver Belastung. Passt gut.",
        stress: "Verstehe. Ashwagandha könnte hier eine hilfreiche Ergänzung sein, das nehme ich mit auf."
      }
    },
    it: {
      q1: {
        energy: "Perfetto, metabolismo energetico! Guarderò soprattutto le vitamine B, che contribuiscono al normale metabolismo energetico. Vediamo cos'altro si adatta.",
        immune: "Sistema immunitario, capito. Vitamina D, zinco e vitamina C contribuiscono tutti alla normale funzione del sistema immunitario. Ti preparerò qualcosa di buono.",
        beauty: "Beauty, bel tema! La biotina contribuisce al mantenimento di pelle e capelli normali. Lo analizzerò per te.",
        sport: "Allenamento, perfetto! Le proteine contribuiscono al mantenimento della massa muscolare e il magnesio al normale metabolismo energetico. Ho delle buone opzioni.",
        sleep: "Supporto per il sonno, perfetto. Il magnesio contribuisce alla normale funzione del sistema nervoso. Buona base per la tua routine serale!",
        focus: "Focus, capito! B1, B6 e B12 contribuiscono alla normale funzione psicologica e il magnesio alla normale funzione del sistema nervoso. Possiamo fare qualcosa."
      },
      q2: {
        female: "Buono a sapersi! Per le donne il ferro può essere un'integrazione utile a seconda dell'area. Lo includerò se necessario.",
        male: "Va bene, lo terrò in considerazione nella selezione.",
        diverse: "Capito, mi orienterò in base alle tue altre risposte.",
        none: "Nessun problema, mi orienterò in base alle tue altre risposte."
      },
      q3: {
        '18-35': "Perfetto! In questa fase della vita, una buona base di nutrienti è spesso la chiave. Darò un'occhiata!",
        '36-50': "Buono a sapersi. Dai 30 anni in poi, un'integrazione mirata di micronutrienti può essere un supporto utile.",
        '51+': "Va bene! In questa fase della vita, il mantenimento della massa muscolare è importante. Le proteine contribuiscono proprio a questo, lo terrò in considerazione."
      },
      q4: {
        omni: "Super, una dieta equilibrata è già una buona base! Tuttavia, un'integrazione mirata può essere utile.",
        vegetarian: "Vegetariano, capito. Sostituirò i prodotti animali con alternative vegetali e integrerò B12 se necessario.",
        vegan: "Vegano, capito! B12 e Omega-3 da olio di alghe li includerò nel tuo stack, perché entrambi non si trovano negli alimenti vegetali.",
        lowfish: "Perfetto. EPA e DHA da Omega-3 contribuiscono alla normale funzione cardiaca, lo aggiungerò."
      },
      q5: {
        desk: "Prevalentemente sedentario, capisco. La vitamina D contribuisce alla normale funzione del sistema immunitario, lo terrò in considerazione.",
        low: "Poco movimento, capito. Mi assicurerò di fornirti una buona base di nutrienti.",
        active: "Bello che tu sia attivo! Il magnesio contribuisce alla normale funzione muscolare, lo includerò.",
        athlete: "Forte, 4x+ a settimana! La creatina aumenta le prestazioni fisiche durante esercizi brevi e intensi. Si adatta bene.",
        stress: "Capisco. L'ashwagandha potrebbe essere un utile supporto, lo aggiungerò."
      }
    },
    es: {
      q1: {
        energy: "¡Perfecto, metabolismo energético! Voy a mirar especialmente las vitaminas B, que contribuyen al metabolismo energético normal. Veamos qué más encaja.",
        immune: "Sistema inmunitario, entendido. La vitamina D, el zinc y la vitamina C contribuyen a la función normal del sistema inmunitario. Te prepararé algo bueno.",
        beauty: "¡Beauty, bonito tema! La biotina contribuye al mantenimiento normal de la piel y el cabello. Lo analizaré para ti.",
        sport: "¡Entrenamiento, perfecto! Las proteínas contribuyen al mantenimiento de la masa muscular y el magnesio al metabolismo energético normal. Tengo buenas opciones.",
        sleep: "Apoyo para el sueño, perfecto. El magnesio contribuye a la función normal del sistema nervioso. ¡Buena base para tu rutina nocturna!",
        focus: "¡Concentración, entendido! B1, B6 y B12 contribuyen a la función psicológica normal y el magnesio a la función normal del sistema nervioso. Podemos hacer algo."
      },
      q2: {
        female: "¡Bueno saberlo! Para las mujeres, el hierro puede ser un complemento útil según el área. Lo incluiré si es necesario.",
        male: "Entendido, lo tendré en cuenta en la selección.",
        diverse: "Entendido, me guiaré por tus otras respuestas.",
        none: "No hay problema, me guiaré por tus otras respuestas."
      },
      q3: {
        '18-35': "¡Perfecto! En esta etapa de la vida, una buena base de nutrientes suele ser la clave. ¡Voy a echar un vistazo!",
        '36-50': "Bueno saberlo. A partir de los 30 años, un aporte específico de micronutrientes puede ser un apoyo útil.",
        '51+': "¡Entendido! En esta etapa de la vida, el mantenimiento de la masa muscular es importante. Las proteínas contribuyen precisamente a eso, lo tendré en cuenta."
      },
      q4: {
        omni: "¡Super, una dieta equilibrada ya es una buena base! Aun así, una suplementación específica puede ser útil.",
        vegetarian: "Vegetariano, entendido. Sustituiré los productos animales por alternativas vegetales e integraré B12 si es necesario.",
        vegan: "¡Vegano, entendido! B12 y Omega-3 de aceite de algas los incluiré en tu stack, porque ambos no se encuentran en alimentos vegetales.",
        lowfish: "Perfecto. EPA y DHA de Omega-3 contribuyen a la función cardíaca normal, lo añadiré."
      },
      q5: {
        desk: "Principalmente sentado, entiendo. La vitamina D contribuye a la función normal del sistema inmunitario, lo tendré en cuenta.",
        low: "Poco movimiento, entendido. Me aseguraré de darte una buena base de nutrientes.",
        active: "¡Genial que seas activo! El magnesio contribuye a la función muscular normal, lo incluiré.",
        athlete: "¡Fuerte, 4x+ por semana! La creatina aumenta el rendimiento físico durante ejercicios breves e intensos. Encaja bien.",
        stress: "Entiendo. La ashwagandha podría ser un apoyo útil, lo añadiré."
      }
    }
  };
  return insights[LOCALE];
})();
window.NEQuiz = {
  answers: { q1: null, q2: null, q3: null, q4: null, q5: null },
  sessionId: null,
  activeTimers: {},
  advanceTimer: null,
  _trackingProcessStarted: false,
  _trackingResultsSent: false,
  _STEP_MAP: {
    1: { num: '01.', name: 'Hauptziel' },
    2: { num: '02.', name: 'Eigenbild' },
    3: { num: '03.', name: 'Alter' },
    4: { num: '04.', name: 'Ernaehrung' },
    5: { num: '05.', name: 'Alltag' },
    6: { num: '06.', name: 'Ergebnis' }
  },
  _ANSWER_KEYS: {
    q1: 'Quiztool Antwort Hauptziel',
    q2: 'Quiztool Antwort Eigenbild',
    q3: 'Quiztool Antwort Alter',
    q4: 'Quiztool Antwort Ernaehrung',
    q5: 'Quiztool Antwort Alltag'
  },
  _getProcessPrefix() {
    if (LOCALE === 'it' || LOCALE === 'es') return 'NE';
    return 'NE';
  },
  _getProcessName() {
    return this._getProcessPrefix() + '-Quiztool';
  },
  _buildPageObject(stepNum) {
    var stepInfo = this._STEP_MAP[stepNum];
    if (!stepInfo) return null;

    return {
      name: 'Produktassistent',
      type: 'processPage',
      realm: 'natural-elements'
      // parsedUrl und parsedReferrer WEGLASSEN - Matomo füllt automatisch
    };
  },
  _buildAttributes(upToQuestion) {
    var attrs = [];
    var keys = ['q1','q2','q3','q4','q5'];
    for (var i = 0; i < upToQuestion - 1; i++) {
      var qKey = keys[i];
      if (this.answers[qKey]) {
        attrs.push({ key: this._ANSWER_KEYS[qKey], value: this.answers[qKey] });
      }
    }
    return attrs;
  },
  _buildProductList(products) {
    return products.map(function(p) {
      var priceNum = 0;
      if (p.price) {
        var cleaned = p.price.replace(/[^0-9.,]/g, '').replace(',', '.');
        priceNum = parseFloat(cleaned) || 0;
      }
      return {
        product_id: p.handle,
        product_name: p.title,
        product_price: priceNum,
        product_categories: ['Nahrungsergaenzung']
      };
    });
  },
  trackStep(stepNum, extraBusinessEvents, products) {
    // DEBUG: Zeige Tracking-Aktivität in Console
    console.log('[Tracking] Step', stepNum, '- _mtm exists:', !!window._mtm);

    if (!window._mtm) {
      console.warn('[Tracking] _mtm not available!');
      return;
    }

    var stepInfo = this._STEP_MAP[stepNum];
    if (!stepInfo) return;

    var businessEvents = ['step'];
    // "start" nur beim allerersten Kontakt (persistent über Reloads)
    if (!sessionStorage.getItem('ne_quiz_tracking_started')) {
      businessEvents.push('start');
      sessionStorage.setItem('ne_quiz_tracking_started', 'true');
    }
    this._trackingProcessStarted = true;

    if (extraBusinessEvents) {
      for (var i = 0; i < extraBusinessEvents.length; i++) {
        if (businessEvents.indexOf(extraBusinessEvents[i]) === -1) {
          businessEvents.push(extraBusinessEvents[i]);
        }
      }
    }

    _mtm.push({ page: this._buildPageObject(stepNum) });
    var processObj = {
      process: {
        name: this._getProcessName(),
        category: 'selfservice',
        stepNumber: stepInfo.num,
        stepName: stepInfo.name,
        businessEvents: businessEvents
      }
    };
    _mtm.push(processObj);

    var attrs = this._buildAttributes(stepNum);
    if (attrs.length > 0) {
      _mtm.push({ attributes: attrs });
    }

    if (products && products.length > 0) {
      _mtm.push({ ecommerce: { productlist: this._buildProductList(products) } });
    }

    _mtm.push({ event: 'trackPageview' });

    // DEBUG: Zeige Success
    console.log('[Tracking] ✅ Pushed:', stepInfo.name, 'businessEvents:', businessEvents, '_mtm.length:', _mtm.length);
  },
  init() {
    this.sessionId = this.getSessionId();
    this.translateUI();
    this.setupKeyboardNav();
    this.restoreSession();
  },
  restoreSession() {
    try {
      const savedAnswers = sessionStorage.getItem('ne-quiz-answers');
      if (savedAnswers) {
        const parsed = JSON.parse(savedAnswers);
        // Validate that we have all 5 answers
        if (parsed.q1 && parsed.q2 && parsed.q3 && parsed.q4 && parsed.q5) {
          this.answers = parsed;
          console.log('[Session Restore] Restoring quiz results from session');
          // Skip intro and go directly to results
          this.goTo('analyzing');
          setTimeout(() => {
            this.buildResult();
            this.goTo(6);
          }, 100);
        }
      }
    } catch (e) {
      console.warn('[Session Restore] Failed to restore session:', e);
      sessionStorage.removeItem('ne-quiz-answers');
    }
  },
  saveSession() {
    try {
      sessionStorage.setItem('ne-quiz-answers', JSON.stringify(this.answers));
      console.log('[Session Save] Quiz results saved to session');
    } catch (e) {
      console.warn('[Session Save] Failed to save session:', e);
    }
  },
  translateUI() {
    const eyebrow = document.querySelector('.ne-quiz-intro-eyebrow');
    const headline = document.querySelector('.ne-quiz-intro h1');
    const subline = document.querySelector('.ne-quiz-intro > p');
    const features = document.querySelectorAll('.ne-quiz-feature');
    const introCTA = document.querySelector('#ne-quiz-start-btn');
    const disclaimer = document.querySelector('.ne-quiz-disclaimer');
    if (eyebrow) eyebrow.innerHTML = t.intro_eyebrow;
    if (headline) headline.innerHTML = t.intro_headline;
    if (subline) subline.textContent = t.intro_subline;
    if (introCTA) introCTA.textContent = t.intro_cta;
    const disclaimerText = document.querySelector('.ne-quiz-disclaimer-text');
    if (disclaimerText) disclaimerText.innerHTML = t.intro_disclaimer;
    const q1Title = document.querySelector('#ne-quiz-q1 h2');
    if (q1Title) q1Title.textContent = t.q1_title;
    const q1Subline = document.querySelector('#ne-quiz-q1 p');
    if (q1Subline) q1Subline.textContent = t.q1_subline;
    const q1Options = document.querySelectorAll('#ne-quiz-q1 .ne-quiz-option-title');
    if (q1Options[0]) q1Options[0].textContent = t.q1_energy;
    if (q1Options[1]) q1Options[1].textContent = t.q1_immune;
    if (q1Options[2]) q1Options[2].textContent = t.q1_beauty;
    if (q1Options[3]) q1Options[3].textContent = t.q1_sport;
    if (q1Options[4]) q1Options[4].textContent = t.q1_sleep;
    if (q1Options[5]) q1Options[5].textContent = t.q1_focus;
    const q2Title = document.querySelector('#ne-quiz-q2 h2');
    if (q2Title) q2Title.textContent = t.q2_title;
    const q2Options = document.querySelectorAll('#ne-quiz-q2 .ne-quiz-option-title');
    if (q2Options[0]) q2Options[0].textContent = t.q2_female;
    if (q2Options[1]) q2Options[1].textContent = t.q2_male;
    if (q2Options[2]) q2Options[2].textContent = t.q2_diverse;
    if (q2Options[3]) q2Options[3].textContent = t.q2_none;
    const q3Title = document.querySelector('#ne-quiz-q3 h2');
    if (q3Title) q3Title.textContent = t.q3_title;
    const q3Options = document.querySelectorAll('#ne-quiz-q3 .ne-quiz-option-title');
    if (q3Options[0]) q3Options[0].textContent = t.q3_18_35;
    if (q3Options[1]) q3Options[1].textContent = t.q3_36_50;
    if (q3Options[2]) q3Options[2].textContent = t.q3_51plus;
    const q4Title = document.querySelector('#ne-quiz-q4 h2');
    if (q4Title) q4Title.textContent = t.q4_title;
    const q4Options = document.querySelectorAll('#ne-quiz-q4 .ne-quiz-option-title');
    if (q4Options[0]) q4Options[0].textContent = t.q4_omni;
    if (q4Options[1]) q4Options[1].textContent = t.q4_vegetarian;
    if (q4Options[2]) q4Options[2].textContent = t.q4_vegan;
    if (q4Options[3]) q4Options[3].textContent = t.q4_lowfish;
    const q5Title = document.querySelector('#ne-quiz-q5 h2');
    if (q5Title) q5Title.textContent = t.q5_title;
    const q5Options = document.querySelectorAll('#ne-quiz-q5 .ne-quiz-option-title');
    if (q5Options[0]) q5Options[0].textContent = t.q5_desk;
    if (q5Options[1]) q5Options[1].textContent = t.q5_low;
    if (q5Options[2]) q5Options[2].textContent = t.q5_active;
    if (q5Options[3]) q5Options[3].textContent = t.q5_athlete;
    if (q5Options[4]) q5Options[4].textContent = t.q5_stress;
    const analyzingTitle = document.querySelector('#ne-quiz-analyzing .ne-quiz-analyzing-title');
    if (analyzingTitle) analyzingTitle.textContent = t.analyzing_title;
    const analyzingSteps = document.querySelectorAll('#ne-quiz-analyzing .ne-quiz-analyzing-step-label');
    if (analyzingSteps[0]) analyzingSteps[0].textContent = t.analyzing_step1;
    if (analyzingSteps[1]) analyzingSteps[1].textContent = t.analyzing_step2;
    if (analyzingSteps[2]) analyzingSteps[2].textContent = t.analyzing_step3;
    const resultLabel = document.querySelector('.ne-quiz-section-label');
    if (resultLabel) resultLabel.textContent = t.result_label;
    const aiLabel = document.querySelector('.ne-quiz-ai-label');
    if (aiLabel) aiLabel.textContent = t.result_ai_label;
    const aiHeadline = document.querySelector('.ne-quiz-ai-headline');
    if (aiHeadline) aiHeadline.textContent = t.result_ai_headline;
    const bundleTitle = document.querySelector('.ne-quiz-bundle-title');
    if (bundleTitle) bundleTitle.textContent = t.bundle_title;
    const bundleBlurb = document.querySelector('#ne-bundle-blurb');
    if (bundleBlurb) bundleBlurb.textContent = t.bundle_blurb;
    const einnahmeplanLabel = document.querySelectorAll('.ne-quiz-section-label')[1];
    if (einnahmeplanLabel) einnahmeplanLabel.textContent = t.einnahmeplan_label;
    const chatLabel = document.querySelector('.ne-quiz-next-label');
    if (chatLabel) chatLabel.textContent = t.chat_label;
    const chatHeadline = document.querySelector('.ne-quiz-next-title');
    if (chatHeadline) chatHeadline.innerHTML = t.chat_headline;
    const chatSubline = document.querySelector('.ne-quiz-next-sub');
    if (chatSubline) chatSubline.textContent = t.chat_subline;
    const chatPlaceholder = document.querySelector('#ne-quick-chat-input');
    if (chatPlaceholder) chatPlaceholder.placeholder = t.chat_placeholder;
    const chatBtn = document.querySelector('.ne-quiz-chat-send-btn');
    if (chatBtn) chatBtn.childNodes[0].textContent = t.chat_btn;
    const toast = document.querySelector('#ne-toast');
    if (toast) toast.textContent = t.toast_plan_sent;
    const featureEls = document.querySelectorAll('.ne-quiz-feature');
    const featureTexts = [t.feature_1, t.feature_2, t.feature_3];
    featureEls.forEach((el, i) => {
      if (featureTexts[i]) {
        const icon = el.querySelector('.ne-quiz-feature-icon');
        el.textContent = '';
        if (icon) el.appendChild(icon);
        el.appendChild(document.createTextNode(' ' + featureTexts[i]));
      }
    });
    const q1Subs = document.querySelectorAll('#ne-quiz-q1 .ne-quiz-option-desc');
    const q1SubTexts = [t.q1_energy_sub, t.q1_immune_sub, t.q1_beauty_sub, t.q1_sport_sub, t.q1_sleep_sub, t.q1_focus_sub];
    q1Subs.forEach((el, i) => { if (q1SubTexts[i]) el.textContent = q1SubTexts[i]; });
    document.querySelectorAll('.ne-quiz-progress-label').forEach((el, i) => {
      el.textContent = t.progress_label.replace('{n}', i + 1);
    });
    document.querySelectorAll('.ne-quiz-insight-label').forEach(el => {
      const dot = el.querySelector('.ne-quiz-insight-label-dot');
      el.textContent = '';
      if (dot) el.appendChild(dot);
      el.appendChild(document.createTextNode(t.buddy_notes));
    });
    const analyzingSub = document.querySelector('#ne-analyzing-status');
    if (analyzingSub) analyzingSub.textContent = t.analyzing_sub;
    const recapTitle = document.querySelector('.ne-quiz-recap-title');
    if (recapTitle) recapTitle.textContent = t.recap_title;
    const aiStatus = document.querySelector('.ne-quiz-ai-status');
    if (aiStatus) aiStatus.textContent = t.ai_status;
    const bundleEyebrow = document.querySelector('.ne-quiz-bundle-eyebrow');
    if (bundleEyebrow) bundleEyebrow.textContent = t.bundle_eyebrow;
    const bundleBadge = document.querySelector('.ne-quiz-bundle-badge');
    if (bundleBadge) bundleBadge.textContent = t.bundle_badge;
    const perks = document.querySelectorAll('.ne-quiz-bundle-perks span');
    const perkTexts = [t.bundle_perk_1, t.bundle_perk_2];
    perks.forEach((el, i) => {
      if (perkTexts[i]) {
        const svg = el.querySelector('svg');
        el.textContent = '';
        if (svg) el.appendChild(svg);
        el.appendChild(document.createTextNode('\n                  ' + perkTexts[i]));
      }
    });
    const bundleDisclaimer = document.getElementById('ne-bundle-disclaimer');
    if (bundleDisclaimer) bundleDisclaimer.textContent = t.bundle_disclaimer;
    const restartBtn = document.querySelector('.ne-quiz-restart-btn');
    if (restartBtn) {
      const svg = restartBtn.querySelector('svg');
      restartBtn.textContent = '';
      if (svg) restartBtn.appendChild(svg);
      restartBtn.appendChild(document.createTextNode('\n            ' + t.restart_btn));
    }
    const eyebrows = [
      { sel: '#ne-quiz-q1 .ne-quiz-question-eyebrow', key: 'eyebrow_q1' },
      { sel: '#ne-quiz-q2 .ne-quiz-question-eyebrow', key: 'eyebrow_q2' },
      { sel: '#ne-quiz-q3 .ne-quiz-question-eyebrow', key: 'eyebrow_q3' },
      { sel: '#ne-quiz-q4 .ne-quiz-question-eyebrow', key: 'eyebrow_q4' },
      { sel: '#ne-quiz-q5 .ne-quiz-question-eyebrow', key: 'eyebrow_q5' }
    ];
    eyebrows.forEach(e => {
      const el = document.querySelector(e.sel);
      if (el) el.textContent = t[e.key];
    });
    const q2Sub = document.querySelector('#ne-quiz-q2 .ne-quiz-question > p');
    if (q2Sub) q2Sub.textContent = t.q2_sub;
    const q3Sub = document.querySelector('#ne-quiz-q3 .ne-quiz-question > p');
    if (q3Sub) q3Sub.textContent = t.q3_sub;
    const q4Sub = document.querySelector('#ne-quiz-q4 .ne-quiz-question > p');
    if (q4Sub) q4Sub.textContent = t.q4_sub;
    const q5Sub = document.querySelector('#ne-quiz-q5 .ne-quiz-question > p');
    if (q5Sub) q5Sub.textContent = t.q5_sub;
    document.querySelectorAll('.ne-quiz-btn-back').forEach((btn, i) => {
      const svg = btn.querySelector('svg');
      const txt = i === 0 ? t.btn_back_start : t.btn_back;
      btn.textContent = '';
      if (svg) btn.appendChild(svg);
      btn.appendChild(document.createTextNode('\n          ' + txt));
    });
  },
  getSessionId() {
    let sid = sessionStorage.getItem('ne-quiz-session-id');
    if (!sid) {
      sid = 'quiz-' + Date.now() + '-' + Math.random().toString(36).substring(2, 11);
      sessionStorage.setItem('ne-quiz-session-id', sid);
    }
    return sid;
  },
  setupKeyboardNav() {
    document.addEventListener('keydown', (e) => {
      const quizRoot = document.querySelector('.ne-quiz');
      if (!quizRoot) return;
      const currentScreen = document.querySelector('.ne-quiz-screen.active');
      if (!currentScreen) return;
      if (e.key === 'Enter') {
        const introBtn = currentScreen.querySelector('#ne-quiz-intro .ne-quiz-btn');
        if (introBtn) introBtn.click();
      }
      if (e.key === 'Escape') {
        const backBtn = currentScreen.querySelector('.ne-quiz-btn-back');
        if (backBtn) backBtn.click();
      }
      if (e.key === ' ' && e.target.classList.contains('ne-quiz-option')) {
        e.preventDefault();
        e.target.click();
      }
    });
  },
  goTo(step) {
    if (this.advanceTimer) {
      clearTimeout(this.advanceTimer);
      this.advanceTimer = null;
    }
    document.querySelectorAll('.ne-quiz-screen').forEach(s => s.classList.remove('active'));
    let targetId;
    if (step === 0) targetId = 'ne-quiz-intro';
    else if (step === 'analyzing') targetId = 'ne-quiz-analyzing';
    else if (step === 6) targetId = 'ne-quiz-result';
    else targetId = 'ne-quiz-q' + step;
    const targetEl = document.getElementById(targetId);
    if (!targetEl) {
      console.error('[Quiz] Screen not found:', targetId);
      return;
    }
    targetEl.classList.add('active');
    const container = document.querySelector('.ne-quiz-container');
    if (step === 6) {
      container.classList.add('ne-quiz-full-width');
      window.scrollTo({ top: 0 });
      this.buildResult();
    } else {
      container.classList.remove('ne-quiz-full-width');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (typeof step === 'number' && step >= 1 && step <= 5) {
      this.trackStep(step);
    }
  },
  analyze() {
    this.goTo('analyzing');
    const steps = [
      { text: t.analyzing_status1, delay: 400 },
      { text: t.analyzing_status2, delay: 900 },
      { text: t.analyzing_status3, delay: 1400 },
      { text: t.analyzing_status4, delay: 1900 }
    ];
    const stepsContainer = document.getElementById('ne-analyzing-steps');
    stepsContainer.innerHTML = '';
    steps.forEach((step) => {
      const stepEl = document.createElement('div');
      stepEl.className = 'ne-quiz-analyzing-step';
      stepEl.innerHTML = `
        <div class="ne-quiz-analyzing-step-mark"></div>
        <span>${step.text}</span>
      `;
      stepsContainer.appendChild(stepEl);
    });
    const stepElements = stepsContainer.querySelectorAll('.ne-quiz-analyzing-step');
    steps.forEach((step, idx) => {
      setTimeout(() => {
        stepElements[idx].classList.add('done');
        if (idx === steps.length - 1) {
          document.getElementById('ne-analyzing-status').textContent = t.analyzing_done;
        }
      }, step.delay);
    });
    setTimeout(() => {
      this.goTo(6);
    }, 2600);
  },
  pickOne(el, question) {
    el.closest('.ne-quiz-question').querySelectorAll('.ne-quiz-option').forEach(opt => opt.classList.remove('selected'));
    el.classList.add('selected');
    this.answers[question] = el.dataset.value;
    if (this.advanceTimer) {
      clearTimeout(this.advanceTimer);
      this.advanceTimer = null;
    }
    const answerValue = el.dataset.value;
    const insightText = NEQuizInsights[question]?.[answerValue];
    const questionNum = parseInt(question.replace('q', ''));
    const isLastQuestion = questionNum === 5;
    const advance = () => {
      this.advanceTimer = null;
      isLastQuestion ? this.analyze() : this.goTo(questionNum + 1);
    };
    if (insightText) {
      const boxEl = document.getElementById('ne-insight-' + question);
      const textEl = document.getElementById('ne-insight-text-' + question);
      const timerId = 'insight-' + question;
      if (this.activeTimers[timerId]) {
        clearInterval(this.activeTimers[timerId]);
      }
      boxEl.classList.add('show');
      textEl.textContent = '';
      if (window.innerWidth < 768) {
        setTimeout(() => {
          boxEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 80);
      }
      this.typeText(textEl, insightText, 20, timerId, () => {
        this.advanceTimer = setTimeout(advance, 1100);
      });
    } else {
      this.advanceTimer = setTimeout(advance, 900);
    }
  },
  typeText(element, text, speed, timerId, onComplete) {
    let i = 0;
    element.textContent = '';
    const timer = setInterval(() => {
      if (i < text.length) {
        element.textContent += text.charAt(i);
        i++;
      } else {
        clearInterval(timer);
        if (timerId) delete this.activeTimers[timerId];
        if (onComplete) onComplete();
      }
    }, speed);
    if (timerId) this.activeTimers[timerId] = timer;
  },
  buildAIText() {
    const q1 = this.answers.q1;
    const q2 = this.answers.q2;
    const q3 = this.answers.q3;
    const q4 = this.answers.q4;
    const q5 = this.answers.q5;
    const finalStack = this.applyOverrideRules();
    const stackHandles = finalStack.map(p => p.handle.toLowerCase()).join('|');
    const hasInStack = (keyword) => stackHandles.includes(keyword);
    let text = t.ai_intro + " ";
    if (q1 === 'energy') text += t.ai_stack_energy;
    else if (q1 === 'immune') text += t.ai_stack_immune;
    else if (q1 === 'beauty') text += t.ai_stack_beauty;
    else if (q1 === 'sport') text += t.ai_stack_sport;
    else if (q1 === 'sleep') text += t.ai_stack_sleep;
    else if (q1 === 'focus') text += t.ai_stack_focus;
    text += "<br><br>";
    if (q4 === 'vegan') {
      text += t.ai_vegan_intro + " ";
      if (q1 === 'sport') text += t.ai_vegan_whey + " ";
      text += t.ai_vegan_why + "<br><br>";
    } else if (q4 === 'vegetarian' && hasInStack('b12')) {
      text += t.ai_vegetarian + "<br><br>";
    } else if (q4 === 'lowfish' && (hasInStack('omega') || hasInStack('algenol'))) {
      text += t.ai_lowfish + "<br><br>";
    }
    const parts = [];
    if (q1 === 'energy') {
      if (hasInStack('d3') || hasInStack('vitamin-d')) parts.push(t.ai_d3_energy);
      if (hasInStack('magnesium')) parts.push(t.ai_mag_energy);
      if (hasInStack('b-komplex') || hasInStack('vitamin-b')) parts.push(t.ai_bvitamins_energy);
      if (hasInStack('eisen')) parts.push(t.ai_iron);
      if (hasInStack('b12')) parts.push(t.ai_b12);
      if (hasInStack('omega') || hasInStack('algenol')) parts.push(t.ai_omega3);
    } else if (q1 === 'immune') {
      if (hasInStack('d3') || hasInStack('vitamin-d')) parts.push(t.ai_d3_immune);
      if (hasInStack('zink')) parts.push(t.ai_zinc_immune);
      if (hasInStack('vitamin-c')) parts.push(t.ai_vitc_immune);
      if (hasInStack('eisen')) parts.push(t.ai_iron);
      if (hasInStack('b12')) parts.push(t.ai_b12);
      if (hasInStack('omega') || hasInStack('algenol')) parts.push(t.ai_omega3);
    } else if (q1 === 'beauty') {
      if (hasInStack('biotin')) parts.push(t.ai_biotin_beauty);
      if (hasInStack('hyaluron') || hasInStack('kollagen') || hasInStack('ialuronico') || hasInStack('hialuronico')) parts.push(t.ai_hyaluron_beauty);
      if (hasInStack('omega') || hasInStack('algenol')) parts.push(t.ai_omega3);
      if (hasInStack('eisen')) parts.push(t.ai_iron);
      if (hasInStack('b12')) parts.push(t.ai_b12);
    } else if (q1 === 'sport') {
      if (hasInStack('kreatin') || hasInStack('creatina')) parts.push(t.ai_kreatin_sport);
      if (hasInStack('magnesium')) parts.push(t.ai_mag_sport);
      if (hasInStack('protein') || hasInStack('whey') || hasInStack('arginina')) parts.push(t.ai_protein_sport);
      if (hasInStack('b12')) parts.push(t.ai_b12);
      if (hasInStack('omega') || hasInStack('algenol')) parts.push(t.ai_omega3_algenoel);
    } else if (q1 === 'sleep') {
      if (hasInStack('magnesium')) parts.push(t.ai_magbis_sleep);
      if (hasInStack('ashwagandha')) parts.push(t.ai_ashwa_sleep);
      if (hasInStack('melatonin')) parts.push(t.ai_melatonin_sleep);
    } else if (q1 === 'focus') {
      if (hasInStack('ginkgo')) {
        parts.push(t.ai_ginkgo_focus);
      } else if (hasInStack('magnesium') && hasInStack('threonat')) {
        parts.push(t.ai_magthreo_focus_p1);
      }
      if (hasInStack('b-komplex') || hasInStack('vitamin-b') || hasInStack('vitaminico-b')) parts.push(t.ai_bvitamins_focus);
      if (hasInStack('magnesium') && hasInStack('complesso') && !hasInStack('threonat')) parts.push(t.ai_mag_sport);
    }
    if (parts.length) text += parts.join(' ') + '<br><br>';
    const ironMentioned = text.toLowerCase().includes('eisen') || text.toLowerCase().includes('ferro') || text.toLowerCase().includes('hierro');
    const omegaMentioned = text.toLowerCase().includes('omega');
    const kreatinMentioned = text.toLowerCase().includes('kreatin') || text.toLowerCase().includes('creatina');
    const ashwaMentioned = text.toLowerCase().includes('ashwagandha');
    const magMentioned = text.toLowerCase().includes('magnesium') || text.toLowerCase().includes('magnesio');
    const b12Mentioned = text.toLowerCase().includes('b12');
    if (q2 === 'female' && (hasInStack('eisen') || hasInStack('ferro') || hasInStack('hierro')) && !ironMentioned) {
      text += t.ai_female_iron + "<br><br>";
    }
    if (q5 === 'athlete' && (hasInStack('kreatin') || hasInStack('creatina')) && !kreatinMentioned) {
      text += t.ai_athlete + "<br><br>";
    } else if (q5 === 'active' && hasInStack('magnesium') && !magMentioned) {
      text += t.ai_active_mag + "<br><br>";
    }
    text += t.ai_closing;
    return text;
  },
  buildRecapChips() {
    const goalLabels = { energy: t.q1_energy, immune: t.q1_immune, beauty: t.q1_beauty, sport: t.q1_sport, sleep: t.q1_sleep, focus: t.q1_focus };
    const genderLabels = { female: t.q2_female, male: t.q2_male, diverse: t.q2_diverse, none: t.q2_none };
    const ageLabels = { '18-35': t.q3_18_35, '36-50': t.q3_36_50, '51+': t.q3_51plus };
    const dietLabels = { omni: t.q4_omni, vegetarian: t.q4_vegetarian, vegan: t.q4_vegan, lowfish: t.q4_lowfish };
    const lifeLabels = { desk: t.q5_desk, low: t.q5_low, active: t.q5_active, athlete: t.q5_athlete, stress: t.q5_stress };
    const icons = {
      q1: '<svg class="ic" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="3.5" stroke="currentColor" stroke-width="1.5"/><path d="M12 3v2M12 19v2M3 12h2M19 12h2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
      q2: '<svg class="ic" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.5"/><path d="M6 20c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
      q3: '<svg class="ic" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/><path d="M12 7v5l3 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
      q4: '<svg class="ic" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 3C8 3 5 6 5 10c0 5 7 11 7 11s7-6 7-11c0-4-3-7-7-7z" stroke="currentColor" stroke-width="1.5"/></svg>',
      q5: '<svg class="ic" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };
    const cards = [
      { lbl: t.recap_goal, val: goalLabels[this.answers.q1] || '—', ic: icons.q1 },
      { lbl: t.recap_gender, val: genderLabels[this.answers.q2] || '—', ic: icons.q2 },
      { lbl: t.recap_age, val: ageLabels[this.answers.q3] || '—', ic: icons.q3 },
      { lbl: t.recap_diet, val: dietLabels[this.answers.q4] || '—', ic: icons.q4 },
      { lbl: t.recap_lifestyle, val: lifeLabels[this.answers.q5] || '—', ic: icons.q5 }
    ];
    const grid = document.getElementById('ne-recap-grid');
    const section = document.getElementById('ne-recap-section');
    if (!grid || !section) return;
    grid.innerHTML = cards.map(c => `
      <div class="ne-quiz-recap-card">
        ${c.ic}
        <div class="lbl">${c.lbl}</div>
        <div class="val">${c.val}</div>
      </div>
    `).join('');
    section.style.display = '';
  },
  streamAI() {
    const aiText = this.buildAIText();
    const aiEl = document.getElementById('ne-ai-stream');
    const cursor = document.createElement('span');
    cursor.className = 'ne-quiz-ai-cursor';
    aiEl.innerHTML = '';
    aiEl.appendChild(cursor);
    let i = 0;
    const speed = 15;
    const timer = setInterval(() => {
      if (i >= aiText.length) {
        clearInterval(timer);
        cursor.remove();
        return;
      }
      if (aiText[i] === '<') {
        const end = aiText.indexOf('>', i);
        i = end !== -1 ? end + 1 : i + 1;
      } else {
        i++;
      }
      aiEl.innerHTML = aiText.substring(0, i);
      aiEl.appendChild(cursor);
    }, speed);
  },
  applyOverrideRules() {
    const q1 = this.answers.q1; // Ziel
    const q2 = this.answers.q2; // Geschlecht
    const q3 = this.answers.q3; // Alter
    const q4 = this.answers.q4; // Ernährung
    const q5 = this.answers.q5; // Alltag
    let products = NEQuizProducts[q1] ? [...NEQuizProducts[q1]] : [];
    products = products.filter(Boolean);
    console.log('[DEBUG] Initial stack:', products.map(p => p?.handle || 'null'));
    const keywordAliases = {
      'b-komplex': ['b-komplex', 'complesso-vitaminico-b', 'complejo-de-vitamina-b'],
      'algenol': ['algenol', 'alghe-omega', 'algas-omega'],
      'eisen': ['eisen', 'ferro', 'hierro'],
      'iron': ['eisen', 'ferro', 'hierro'],
      'protein': ['protein', 'whey', 'l-arginina'],
      'whey': ['whey', 'l-arginina'],
      'kreatin': ['kreatin', 'creatina']
    };
    const has = (keyword) => {
      const terms = keywordAliases[keyword] || [keyword];
      return products.some(p => {
        if (!p?.handle) return false;
        const h = p.handle.toLowerCase();
        return terms.some(t => h.includes(t));
      });
    };
    const isAnimal = (handle) => {
      if (!handle) return false;
      const h = handle.toLowerCase();
      return h.includes('fischol') || h.includes('fischöl') || h.includes('omega-3-fisch')
        || h.includes('olio-di-pesce') || h.includes('aceite-de-pescado')
        || h.includes('whey') || h.includes('l-arginina')
        || h.includes('kollagen') || h.includes('acido-ialuronico') || h.includes('acido-hialuronico')
        || h === 'vitamin-d3-k2-tropfen' || h === 'gocce-di-vitamina-d3-k2' || h === 'gotas-de-vitamina-d3-k2';
    };
    const locked = new Set();
    if (q4 === 'vegan') {
      const isD3K2 = (h) => h === 'vitamin-d3-k2-tropfen' || h === 'gocce-di-vitamina-d3-k2' || h === 'gotas-de-vitamina-d3-k2';
      if (products[0] && isD3K2(products[0].handle)) {
        if (['energy', 'immune', 'beauty'].includes(q1)) {
          products[0] = NEExtraProducts.iron;
        } else {
          products[0] = NEExtraProducts.b12; // für andere Stacks B12 als P1
        }
      }
      if (products[0] && isAnimal(products[0].handle)) {
        products[0] = NEExtraProducts.iron;
      }
      products[1] = NEExtraProducts.algenoel;
      products[2] = NEExtraProducts.b12;
      if (products[0]?.handle === products[2]?.handle) {
        if (['energy', 'immune', 'beauty'].includes(q1)) {
          products[2] = NEExtraProducts.iron;
        } else {
          products[2] = NEExtraProducts.kreatin;
        }
      }
      if (products[0]?.handle === NEExtraProducts.iron.handle && products[2]?.handle === NEExtraProducts.iron.handle) {
        products[2] = NEExtraProducts.b12;
      }
      locked.add(products[0]?.handle);
      locked.add(products[1]?.handle);
      locked.add(products[2]?.handle);
    }
    if (q4 === 'vegetarian') {
      let hasAlgenoel = false;
      for (let i = products.length - 1; i >= 0; i--) {
        const p = products[i];
        if (!p || !isAnimal(p.handle)) continue;
        const h = p.handle.toLowerCase();
        if (h.includes('fischol') || h.includes('fischöl') || h.includes('omega-3-fisch')
          || h.includes('olio-di-pesce') || h.includes('aceite-de-pescado')) {
          products[i] = NEExtraProducts.algenoel;
          hasAlgenoel = true;
        } else if (h.includes('whey') || h.includes('l-arginina')) {
          products[i] = NEExtraProducts.b12;
        } else if (h.includes('kollagen') || h.includes('acido-ialuronico') || h.includes('acido-hialuronico')) {
          if (!hasAlgenoel && !has('omega') && !has('algenol')) {
            products[i] = NEExtraProducts.algenoel;
            hasAlgenoel = true;
          } else {
            products[i] = NEExtraProducts.b12;
          }
        }
      }
      const seen = new Set();
      for (let i = 0; i < products.length; i++) {
        if (!products[i]) continue;
        if (seen.has(products[i].handle)) {
          if (!has('b-komplex') && !products.some((p, j) => j !== i && p?.handle?.includes('b12'))) {
            products[i] = NEExtraProducts.b12;
          } else if (!hasAlgenoel) {
            products[i] = NEExtraProducts.algenoel;
          }
        }
        seen.add(products[i].handle);
      }
      if (!has('b-komplex') && !has('b12')) {
        if (products.length < 3) {
          products.push(NEExtraProducts.b12);
        } else {
          products[2] = NEExtraProducts.b12;
        }
      }
      products.forEach(p => {
        if (p && (p.handle.includes('b12') || p.handle.includes('algenol'))) {
          locked.add(p.handle);
        }
      });
    }
    if (q2 === 'female' && ['energy', 'immune', 'beauty'].includes(q1)) {
      if (!has('eisen') && !has('iron')) {
        if (products.length < 3) {
          products.push(NEExtraProducts.iron);
        } else if (products.length === 3 && !locked.has(products[2]?.handle)) {
          products[2] = NEExtraProducts.iron;
        }
      }
    }
    if (q4 === 'lowfish' && !has('omega')) {
      if (products.length < 3) {
        products.push(NEExtraProducts.omega3);
      } else if (products.length === 3 && !locked.has(products[2]?.handle)) {
        products[2] = NEExtraProducts.omega3;
      }
    }
    if (q3 === '51+' && q4 !== 'vegan' && q4 !== 'vegetarian' && ['energy', 'immune', 'sport'].includes(q1)) {
      if (!has('protein') && !has('whey')) {
        if (products.length < 3) {
          products.push(NEExtraProducts.protein);
        } else if (products.length === 3 && !locked.has(products[2]?.handle)) {
          products[2] = NEExtraProducts.protein;
        }
      }
    }
    if (q5 === 'athlete' && q1 !== 'sport' && !has('kreatin')) {
      if (products.length < 3) {
        products.push(NEExtraProducts.kreatin);
      } else if (products.length === 3 && !locked.has(products[2]?.handle)) {
        products[2] = NEExtraProducts.kreatin;
      }
    }
    if (q5 === 'stress' && q1 !== 'sleep' && !has('ashwagandha')) {
      if (products.length < 3) {
        products.push(NEExtraProducts.ashwagandha);
      } else if (products.length === 3 && !locked.has(products[2]?.handle)) {
        products[2] = NEExtraProducts.ashwagandha;
      }
    }
    const seen = new Set();
    products = products.filter(p => {
      if (!p || !p.handle) return false;
      if (seen.has(p.handle)) {
        console.log('[DEBUG] Duplicate removed:', p.handle);
        return false;
      }
      seen.add(p.handle);
      return true;
    });
    // FALLBACK: Ensure always 3 products
    while (products.length < 3) {
      let fallbackProduct = null;
      // Smart fallback based on quiz answers
      if (q4 === 'vegetarian' || q4 === 'vegan') {
        // For vegetarian/vegan: prioritize Omega-3 Algenöl
        if (!has('omega') && !has('algenol')) {
          fallbackProduct = NEExtraProducts.algenoel;
        } else if (!has('b12')) {
          fallbackProduct = NEExtraProducts.b12;
        } else if (!has('eisen') && !has('iron')) {
          fallbackProduct = NEExtraProducts.iron;
        }
      } else if (q3 === '51+' && !has('protein') && !has('whey')) {
        // For 51+: prioritize protein
        fallbackProduct = NEExtraProducts.protein;
      } else if (!has('omega') && !has('algenol')) {
        // Default: Omega-3
        fallbackProduct = NEExtraProducts.omega3;
      } else if (!has('eisen') && !has('iron')) {
        // Default: Iron
        fallbackProduct = NEExtraProducts.iron;
      }
      if (fallbackProduct && !seen.has(fallbackProduct.handle)) {
        products.push(fallbackProduct);
        seen.add(fallbackProduct.handle);
        console.log('[DEBUG] Fallback added:', fallbackProduct.handle);
      } else {
        // No more fallbacks available, break to avoid infinite loop
        console.warn('[DEBUG] Could not reach 3 products, stopping at', products.length);
        break;
      }
    }
    console.log('[DEBUG] Final stack:', products.map(p => `${p.title} (${p.handle})`));
    return products.slice(0, 3);
  },
  getDynamicBundleText() {
    const goal = this.answers.q1 || 'immune';
    const age = this.answers.q3;
    const diet = this.answers.q4;
    const lifestyle = this.answers.q5;
    const gender = this.answers.q2;
    const titles = {
      energy: t.bundle_energy,
      immune: t.bundle_immune,
      beauty: t.bundle_beauty,
      sport: t.bundle_sport,
      sleep: t.bundle_sleep,
      focus: t.bundle_focus
    };
    let subtitle = '';
    if (diet === 'vegan') {
      subtitle = t.sub_vegan;
    } else if (diet === 'vegetarian') {
      subtitle = t.sub_vegetarian;
    } else if (age === '51+') {
      subtitle = t.sub_51plus;
    } else if (lifestyle === 'athlete') {
      subtitle = t.sub_athlete;
    } else if (lifestyle === 'stress') {
      subtitle = t.sub_stress;
    } else if (gender === 'female' && (goal === 'energy' || goal === 'immune' || goal === 'beauty')) {
      subtitle = t.sub_female_beauty;
    } else if (diet === 'lowfish') {
      subtitle = t.sub_lowfish;
    } else {
      subtitle = t.sub_default;
    }
    return {
      badge: t.bundle_eyebrow,
      title: titles[goal] || t.bundle_default,
      setTitle: titles[goal] || t.bundle_default_set,
      subtitle: subtitle
    };
  },
  buildResult() {
    const goal = this.answers.q1 || 'immune';
    const meta = NEQuizMeta[goal];
    const products = this.applyOverrideRules();
    const bundleText = this.getDynamicBundleText();
    // "success" nur beim ersten Erreichen der Ergebnis-Seite (nicht bei Reload)
    if (!this._trackingResultsSent) {
      this._trackingResultsSent = true;
      if (!sessionStorage.getItem('ne_quiz_tracking_success')) {
        sessionStorage.setItem('ne_quiz_tracking_success', 'true');
        this.trackStep(6, ['success'], products);
      } else {
        // Bei Reload: nur normaler Step ohne "success"
        this.trackStep(6, [], products);
      }
    }
    setTimeout(() => {
      const headerEl = document.getElementById('ne-result-header');
      headerEl.classList.remove('ne-quiz-loading');
      headerEl.innerHTML = `
        <div class="ne-quiz-result-label">${t.result_personal_plan}</div>
        <h2 class="ne-quiz-result-title">${meta.title}</h2>
        <p class="ne-quiz-result-desc">${meta.description}</p>
      `;
      this.buildRecapChips();
      const titleEl = document.getElementById('ne-bundle-title');
      const subtitleEl = document.getElementById('ne-bundle-subtitle');
      const setTitleEl = document.getElementById('ne-bundle-set-title');
      const blurbEl = document.getElementById('ne-bundle-blurb');
      if (titleEl) titleEl.textContent = bundleText.title;
      if (subtitleEl) subtitleEl.textContent = bundleText.subtitle;
      if (setTitleEl) setTitleEl.textContent = bundleText.setTitle;
      if (blurbEl) blurbEl.textContent = bundleText.subtitle;
      const bundlePreview = document.getElementById('ne-bundle-preview');
      if (bundlePreview) {
        const itemsHtml = products
          .filter(p => p && p.image)
          .map(p => `
            <div class="ne-quiz-bundle-preview-item">
              <img src="${p.image}" alt="${p.title}" loading="lazy">
              <div class="ne-quiz-bundle-preview-name">${p.title}</div>
            </div>
          `)
          .join('');
        bundlePreview.innerHTML = itemsHtml;
      }
      const morningProducts = [];
      const eveningProducts = [];
      products.forEach((prod) => {
        if (prod && prod.handle) {
          const dl = prod.dosage.toLowerCase();
          if (dl.includes('abends') || dl.includes('vor dem schlafen') || dl.includes('di sera') || dl.includes('prima di dormire') || dl.includes('por la noche') || dl.includes('antes de dormir')) {
            eveningProducts.push(prod);
          } else {
            morningProducts.push(prod);
          }
        }
      });
      const morningContainer = document.getElementById('ne-r-products-morning');
      morningContainer.classList.remove('ne-quiz-loading');
      if (morningProducts.length > 0) {
        morningContainer.innerHTML = `
          <div class="ne-quiz-intake-col-title">${t.morning}</div>
          <div class="ne-quiz-products">
            ${morningProducts.map((prod, idx) => `
              <div class="ne-quiz-product-info-card"
                   data-element-name="quiz-product-info"
                   data-element-type="Card"
                   data-element-position="Quiz-Results"
                   data-product-handle="${prod.handle}">
                <a href="${prod.url}" target="_blank" class="ne-quiz-product-info-link"
                   data-element-name="quiz-product-link"
                   data-element-type="Link"
                   data-element-position="Quiz-Results-Morning"
                   data-product-handle="${prod.handle}">
                  <img src="${prod.image}" alt="${prod.title}" class="ne-quiz-product-info-img" loading="lazy">
                  <div class="ne-quiz-product-info-content">
                    <div class="ne-quiz-product-info-name">${prod.title}</div>
                    <div class="ne-quiz-product-info-why">${prod.why}</div>
                    <div class="ne-quiz-product-info-dose">${prod.dosage}</div>
                  </div>
                </a>
                <div class="ne-quiz-product-info-right">
                  ${LOCALE === 'de' ? `<div class="ne-quiz-product-info-price">${prod.compareAtPrice || prod.price}</div>` : ''}
                  <button class="ne-quiz-product-add-mini"
                          data-element-name="quiz-product-addtocart"
                          data-element-type="CTA"
                          data-element-position="Quiz-Results"
                          data-product-handle="${prod.handle}"
                          onclick="NEQuiz.addToCart('${prod.handle}', event)"
                          aria-label="${t.btn_add_to_cart}">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8 4v8M4 8h8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                </div>
              </div>
            `).join('')}
          </div>
        `;
      } else {
        morningContainer.innerHTML = '';
        morningContainer.style.display = 'none';
      }
      const eveningContainer = document.getElementById('ne-r-products-evening');
      eveningContainer.classList.remove('ne-quiz-loading');
      if (eveningProducts.length > 0) {
        eveningContainer.innerHTML = `
          <div class="ne-quiz-intake-col-title">${t.evening}</div>
          <div class="ne-quiz-products">
            ${eveningProducts.map((prod, idx) => `
              <div class="ne-quiz-product-info-card"
                   data-element-name="quiz-product-info"
                   data-element-type="Card"
                   data-element-position="Quiz-Results"
                   data-product-handle="${prod.handle}">
                <a href="${prod.url}" target="_blank" class="ne-quiz-product-info-link"
                   data-element-name="quiz-product-link"
                   data-element-type="Link"
                   data-element-position="Quiz-Results-Evening"
                   data-product-handle="${prod.handle}">
                  <img src="${prod.image}" alt="${prod.title}" class="ne-quiz-product-info-img" loading="lazy">
                  <div class="ne-quiz-product-info-content">
                    <div class="ne-quiz-product-info-name">${prod.title}</div>
                    <div class="ne-quiz-product-info-why">${prod.why}</div>
                    <div class="ne-quiz-product-info-dose">${prod.dosage}</div>
                  </div>
                </a>
                <div class="ne-quiz-product-info-right">
                  ${LOCALE === 'de' ? `<div class="ne-quiz-product-info-price">${prod.compareAtPrice || prod.price}</div>` : ''}
                  <button class="ne-quiz-product-add-mini"
                          data-element-name="quiz-product-addtocart"
                          data-element-type="CTA"
                          data-element-position="Quiz-Results"
                          data-product-handle="${prod.handle}"
                          onclick="NEQuiz.addToCart('${prod.handle}', event)"
                          aria-label="${t.btn_add_to_cart}">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8 4v8M4 8h8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                </div>
              </div>
            `).join('')}
          </div>
        `;
      } else {
        eveningContainer.innerHTML = '';
        eveningContainer.style.display = 'none';
      }
      // Hide pricing for IT/ES, show for DE
      if (LOCALE === 'de') {
        const parsePrice = (priceStr) => {
          return parseFloat(priceStr.replace('€', '').replace(',', '.')) || 0;
        };
        const formatPrice = (num) => {
          return num.toFixed(2).replace('.', ',') + ' €';
        };
        const discountPercent = 10;
        const discountFactor = 1 - (discountPercent / 100);
        const totalOriginalFloat = products.reduce((sum, p) => sum + parsePrice(p.compareAtPrice || p.price), 0);
        const originalTotalCents = Math.round(totalOriginalFloat * 100);
        const originalTotal = originalTotalCents / 100;
        const discountedTotalCents = products.reduce((sum, p) => {
          const price = parsePrice(p.compareAtPrice || p.price);
          const discountedCents = Math.ceil(price * 100 * discountFactor);
          return sum + discountedCents;
        }, 0);
        const discountedTotal = discountedTotalCents / 100;
        const savingsCents = originalTotalCents - discountedTotalCents;
        const savings = savingsCents / 100;
        document.getElementById('ne-bundle-final-hero').textContent = formatPrice(discountedTotal);
        document.getElementById('ne-bundle-original-hero').textContent = formatPrice(originalTotal);
        document.getElementById('ne-bundle-savings-inline').textContent = t.savings_prefix + ' ' + formatPrice(savings);
      } else {
        // IT/ES: Hide pricing section and badge
        const pricingSection = document.querySelector('.ne-quiz-bundle-pricing');
        if (pricingSection) pricingSection.style.display = 'none';
        const ctaBadge = document.querySelector('.ne-quiz-bundle-cta-badge');
        if (ctaBadge) ctaBadge.style.display = 'none';
      }
      const bundleBtnText = document.getElementById('ne-bundle-btn-text');
      bundleBtnText.textContent = t.bundle_btn_template.replace('{n}', products.length);
      const aiSection = document.querySelector('.ne-quiz-ai-section');
      if (aiSection) {
        const observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            observer.disconnect();
            this.streamAI();
          }
        }, { threshold: 0.15 });
        observer.observe(aiSection);
      }
      const questionText = t.chat_suggested_q;
      const suggestedQuestionsEl = document.getElementById('ne-quiz-suggested-questions');
      if (suggestedQuestionsEl) {
        suggestedQuestionsEl.innerHTML = '';
        const button = document.createElement('button');
        button.className = 'ne-quiz-chip';
        button.setAttribute('data-element-name', 'quiz-quickchat-suggested');
        button.setAttribute('data-element-type', 'Button');
        button.setAttribute('data-element-position', 'Quiz-Results');
        button.setAttribute('data-question-text', questionText);
        button.onclick = () => this.openChatWithMessage(questionText);
        button.innerHTML = `
          <svg viewBox="0 0 24 24" fill="none"><path d="M24 15.9999V20.9999C24 21.7955 23.6839 22.5586 23.1213 23.1212C22.5587 23.6838 21.7956 23.9999 21 23.9999H16C14.5971 23.9985 13.2192 23.6281 12.0047 22.926C10.7901 22.224 9.78145 21.2148 9.08 19.9999C9.83387 19.9945 10.5852 19.9114 11.322 19.7519C11.8831 20.4535 12.595 21.0199 13.4048 21.4091C14.2146 21.7982 15.1016 22.0001 16 21.9999H21C21.2652 21.9999 21.5196 21.8945 21.7071 21.707C21.8946 21.5195 22 21.2651 22 20.9999V15.9999C21.9998 15.1011 21.7972 14.2139 21.4074 13.4041C21.0175 12.5943 20.4504 11.8826 19.748 11.3219C19.9088 10.5852 19.9933 9.8339 20 9.07989C21.2149 9.78134 22.2241 10.79 22.9262 12.0045C23.6282 13.2191 23.9986 14.597 24 15.9999ZM17.977 9.65089C18.0705 8.36253 17.8856 7.06913 17.4348 5.85859C16.9841 4.64804 16.278 3.54871 15.3646 2.63531C14.4512 1.7219 13.3518 1.01582 12.1413 0.565046C10.9308 0.114271 9.63736 -0.0706368 8.349 0.0228889C6.06592 0.283621 3.95693 1.37007 2.41918 3.07763C0.881427 4.7852 0.0210272 6.99606 0 9.29389L0 14.3339C0 16.8659 1.507 17.9999 3 17.9999H8.7C10.9988 17.9801 13.211 17.1203 14.9198 15.5824C16.6286 14.0446 17.7159 11.9349 17.977 9.65089V9.65089ZM13.95 4.05089C14.6599 4.76239 15.2088 5.61809 15.5593 6.56008C15.9099 7.50207 16.054 8.50837 15.982 9.51089C15.7686 11.2946 14.9105 12.9387 13.5693 14.1338C12.2282 15.3289 10.4964 15.9926 8.7 15.9999H3C2.072 15.9999 2 14.7249 2 14.3339V9.29389C2.00834 7.49826 2.67265 5.76759 3.86792 4.42757C5.06319 3.08754 6.70699 2.23056 8.49 2.01789C8.656 2.00589 8.822 1.99989 8.988 1.99989C9.90927 1.99903 10.8217 2.17973 11.6731 2.53165C12.5245 2.88357 13.2982 3.39982 13.95 4.05089Z" fill="currentColor"/></svg>
          ${questionText}
        `;
        suggestedQuestionsEl.appendChild(button);
      }
      this.saveToSessionStorage();
      this.saveSession(); // Save complete answers for session restore
    }, 600);
  },
  addToCart(productHandle, e) {
    const product = this.applyOverrideRules().find(p => p && p.handle === productHandle);
    if (!product) return;
    const btn = e.target.closest('.ne-quiz-product-add-mini');
    if (!btn) return;
    const originalHTML = btn.innerHTML;
    btn.innerHTML = `<svg viewBox="0 0 24 24" style="width:16px;height:16px;"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="60" stroke-dashoffset="15" style="animation: spin 1s linear infinite;"/></svg>`;
    btn.disabled = true;
    fetch(`/products/${productHandle}.js`)
      .then(r => r.json())
      .then(data => {
        const variantId = data.variants[0].id;
        const productPrice = parseFloat(data.price) / 100;

        // Track addToCart BEFORE adding to cart
        if (window._mtm) {
          _mtm.push({ page: { name: 'Produktassistent', type: 'processPage', realm: 'natural-elements' } });
          _mtm.push({
            ecommerce: {
              product: {
                product_id: data.id.toString(),
                product_name: data.title,
                product_price: productPrice,
                product_category: data.product_type || ''
              }
            }
          });
          _mtm.push({ event: 'trackAddToCart' });
          console.log('[Tracking] trackAddToCart:', data.title);
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId.toString(), quantity: 1 })
        });
      })
      .then(() => {
        console.log('[Quiz] Product added to cart');
        btn.innerHTML = `<svg viewBox="0 0 24 24" style="width:16px;height:16px;stroke:currentColor;fill:none;stroke-width:3;"><polyline points="20 6 9 17 4 12"/></svg>`;
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        setTimeout(() => {
          const cartIcon = document.querySelector('[data-js-cart-icon]');
          if (cartIcon) {
            cartIcon.click();
          } else {
            const cartDrawerTrigger = document.querySelector('.cart-drawer__toggle, [data-cart-drawer-toggle], .js-cart-drawer-toggle');
            if (cartDrawerTrigger) cartDrawerTrigger.click();
          }
        }, 300);
        setTimeout(() => {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }, 2000);
      })
      .catch(err => {
        console.error('[Quiz] Error:', err);
        btn.innerHTML = `<svg viewBox="0 0 24 24" style="width:16px;height:16px;stroke:currentColor;fill:none;stroke-width:3;"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
        setTimeout(() => {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }, 2000);
      });
  },
  addBundleToCart() {
    const products = this.applyOverrideRules();
    const btn = document.getElementById('ne-bundle-add-btn');
    const btnText = document.getElementById('ne-bundle-btn-text');
    const originalText = btnText.textContent;
    btnText.textContent = t.cart_adding;
    btn.disabled = true;
    const promises = products.map(p =>
      fetch(`/products/${p.handle}.js`).then(r => r.json())
    );
    Promise.all(promises)
      .then(productData => {
        const items = productData.map(data => ({
          id: parseInt(data.variants[0].id),
          quantity: 1
        }));

        // Track addToCart for ALL 3 products BEFORE adding to cart
        if (window._mtm) {
          _mtm.push({ page: { name: 'Produktassistent', type: 'processPage', realm: 'natural-elements' } });
          const productList = productData.map(data => ({
            product_id: data.id.toString(),
            product_name: data.title,
            product_price: parseFloat(data.price) / 100,
            product_category: data.product_type || 'Nahrungsergänzung'
          }));
          _mtm.push({ ecommerce: { product: productList } });
          _mtm.push({ event: 'trackAddToCart' });
          console.log('[Tracking] trackAddToCart Bundle:', productData.map(d => d.title).join(', '));
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(() => {
        btnText.textContent = t.cart_added;
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        setTimeout(() => {
          window.location.href = '/discount/QUIZ10?redirect=/checkout';
        }, 500);
      })
      .catch(err => {
        console.error('[Quiz] Error:', err);
        btnText.textContent = t.cart_error;
        setTimeout(() => {
          btnText.textContent = originalText;
          btn.disabled = false;
        }, 3000);
      });
  },
  getQuizContext() {
    const goalMap = {
      energy: 'Energiestoffwechsel unterstützen',
      immune: 'Immunsystem unterstützen',
      beauty: 'Beauty (Haut, Haare, Nägel)',
      sport: 'Trainings-Support',
      sleep: 'Schlaf-Support',
      focus: 'Fokus & kognitive Funktion'
    };
    const genderMap = {
      female: 'weiblich',
      male: 'männlich',
      diverse: 'divers',
      none: 'keine Angabe'
    };
    const ageMap = {
      '18-35': '18-35 Jahre',
      '36-50': '36-50 Jahre',
      '51+': '51+ Jahre'
    };
    const dietMap = {
      omni: 'ausgewogen',
      vegetarian: 'vegetarisch',
      vegan: 'vegan',
      lowfish: 'wenig Fisch'
    };
    const lifeMap = {
      desk: 'hauptsächlich sitzend',
      low: 'wenig Bewegung',
      active: 'moderat aktiv',
      athlete: 'sehr aktiv',
      stress: 'viel Stress'
    };
    const products = this.applyOverrideRules();
    const productNames = products.map(p => p.title).join(', ');
    const productLinks = products.map(p => `${p.title}: ${new URL(p.url, window.location.origin).href}`).join(' | ');
    return `[Quiz-Kontext] Mein Ziel: ${goalMap[this.answers.q1] || 'unbekannt'} | Geschlecht: ${genderMap[this.answers.q2] || 'unbekannt'} | Alter: ${ageMap[this.answers.q3] || 'unbekannt'} | Ernährung: ${dietMap[this.answers.q4] || 'unbekannt'} | Alltag: ${lifeMap[this.answers.q5] || 'unbekannt'} | Empfohlene Produkte: ${productNames} | Produkt-Links: ${productLinks}`;
  },
  openChat() {
    this.saveToSessionStorage();
    sessionStorage.setItem('ne-quiz-context', this.getQuizContext());
    if (typeof window.toggleChat === 'function') {
      window.toggleChat();
    } else {
      console.warn('Chatbot not available');
      const msg = LOCALE === 'it' ? 'Il chatbot non è disponibile su questa pagina.' : LOCALE === 'es' ? 'El chatbot no está disponible en esta página.' : 'Der Chatbot ist auf dieser Seite nicht verfügbar.';
      alert(msg);
    }
  },
  addUserMessageToChat(text) {
    const messagesContainer = document.getElementById('chat-messages-container');
    if (!messagesContainer) return false;
    const div = document.createElement('div');
    div.className = 'chat-message user';
    div.innerHTML = '<div class="message-bubble">' + this.escapeHtml(text) + '</div>';
    messagesContainer.appendChild(div);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
    this.saveChatMessages();
    return true;
  },
  saveChatMessages() {
    const messagesContainer = document.getElementById('chat-messages-container');
    if (!messagesContainer) return;
    const messages = [];
    messagesContainer.querySelectorAll('.chat-message').forEach(msg => {
      const isUser = msg.classList.contains('user');
      const bubble = msg.querySelector('.message-bubble');
      if (!bubble || msg.id === 'ne-quiz-typing-indicator' || msg.classList.contains('typing-indicator')) return;
      const text = isUser ? bubble.textContent : bubble.innerHTML;
      const data = { type: isUser ? 'user' : 'bot', text: text };
      if (!isUser && msg.dataset.products) {
        data.products = JSON.parse(msg.dataset.products);
      }
      messages.push(data);
    });
    try {
      localStorage.setItem('chat_messages_ne', JSON.stringify(messages));
    } catch (e) {
      console.warn('[Quiz] localStorage write failed:', e);
    }
  },
  showAdvancedTypingIndicator() {
    const messagesContainer = document.getElementById('chat-messages-container');
    if (!messagesContainer) return;
    this.removeTypingIndicator();
    const stages = [
      "Mhh...",
      "Lass mich einmal nachschauen...",
      "Ich hab's fast...",
      "Ich suche die besten Infos für dich...",
      "Gleich geschafft...",
      "Ich arbeite noch daran...",
      "Danke für deine Geduld..."
    ];
    let stageIdx = 0;
    const typingDiv = document.createElement('div');
    typingDiv.className = 'chat-message bot';
    typingDiv.id = 'ne-quiz-typing-indicator';
    typingDiv.innerHTML = '<div class="message-bubble"></div>';
    messagesContainer.appendChild(typingDiv);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
    const bubble = typingDiv.querySelector('.message-bubble');
    const typeWriter = (text, idx, callback) => {
      if (!bubble) return;
      bubble.textContent = text.slice(0, idx);
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
      if (idx < text.length) {
        setTimeout(() => typeWriter(text, idx + 1, callback), 25);
      } else if (callback) {
        setTimeout(callback, 2000);
      }
    };
    const runStage = () => {
      if (!typingDiv.parentNode) return;
      if (stageIdx < stages.length) {
        typeWriter(stages[stageIdx], 0, () => {
          stageIdx++;
          runStage();
        });
      } else {
        stageIdx = 3;
        runStage();
      }
    };
    runStage();
  },
  showDotsIndicator() {
    const messagesContainer = document.getElementById('chat-messages-container');
    if (!messagesContainer) return;
    this.removeTypingIndicator();
    const div = document.createElement('div');
    div.className = 'chat-message bot';
    div.id = 'ne-quiz-typing-indicator';
    div.innerHTML = '<div class="message-bubble"><span class="typing-dot"></span><span class="typing-dot"></span><span class="typing-dot"></span></div>';
    messagesContainer.appendChild(div);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
  },
  removeTypingIndicator() {
    const indicator = document.getElementById('ne-quiz-typing-indicator');
    if (indicator) indicator.remove();
  },
  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  },
  sendQuizMessageToWebhook(userMessage, context) {
    const WEBHOOK_URL = 'https://n8n.srv1048518.hstgr.cloud/webhook/ne-chatbot-v1';
    const sessionId = sessionStorage.getItem('ne-quiz-session-id') || 'quiz-' + Date.now();
    return fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        chatInput: userMessage,
        quizContext: context,
        sessionId: sessionId
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Webhook response not ok');
      return response.json();
    })
    .then(data => {
      this.removeTypingIndicator();
      if (Array.isArray(data) && data.length > 0) {
        const result = data[0];
        const rawMessage = result.message || '';
        const products = result.products || [];
        const parts = rawMessage.split('---').map(p => p.trim()).filter(p => p.length > 0);
        let currentDelay = 0;
        const delayBetween = 4000;
        parts.forEach((part, index) => {
          const isLast = index === parts.length - 1;
          const prods = isLast ? products : [];
          setTimeout(() => {
            this.removeTypingIndicator();
            let htmlMessage = part;
            if (typeof marked !== 'undefined' && typeof marked.parse === 'function') {
              htmlMessage = marked.parse(part);
            }
            this.addBotMessageWithProducts(htmlMessage, prods);
            if (!isLast) {
              this.showDotsIndicator();
            }
          }, currentDelay);
          currentDelay += delayBetween;
        });
      }
    })
    .catch(error => {
      console.error('[Quiz] Webhook error:', error);
      this.removeTypingIndicator();
      const errMsg = LOCALE === 'it' ? 'Mi dispiace, c\'è stato un errore. Riprova.' : LOCALE === 'es' ? 'Lo siento, hubo un error. Inténtalo de nuevo.' : 'Entschuldigung, es gab einen Fehler. Bitte versuche es erneut.';
      this.addBotMessageSimple(errMsg);
    });
  },
  addBotMessageWithProducts(htmlContent, products) {
    const messagesContainer = document.getElementById('chat-messages-container');
    if (!messagesContainer) return;
    const div = document.createElement('div');
    div.className = 'chat-message bot';
    if (products && products.length > 0) {
      div.dataset.products = JSON.stringify(products);
    }
    let content = '<div class="message-bubble">' + htmlContent + '</div>';
    if (products && products.length > 0) {
      content += '<div class="products-container">';
      products.forEach(p => {
        content += `
          <div class="product-card" data-element-name="proposal-teaser" data-element-type="Teaser" data-element-position="Chatbot">
            <a href="${this.escapeHtml(p.url)}" class="product-link" style="flex-shrink:0;">
              <img src="${this.escapeHtml(p.image)}" alt="${this.escapeHtml(p.title)}" class="product-img">
            </a>
            <div class="product-info">
              <a href="${this.escapeHtml(p.url)}" class="product-title-link">
                <div class="product-title">${this.escapeHtml(p.title)}</div>
              </a>
              <div class="product-price">${this.escapeHtml(p.price)} €</div>
              <button type="button" class="ne-quiz-cart-btn" data-element-name="proposal-addtocart" data-element-type="CTA" data-element-position="Chatbot" data-product-handle="${this.escapeHtml(p.handle)}">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px;flex-shrink:0;"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                ${t.btn_add}
              </button>
            </div>
          </div>
        `;
      });
      content += '</div>';
    }
    div.innerHTML = content;
    messagesContainer.appendChild(div);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
    this.saveChatMessages();
  },
  addBotMessageSimple(text) {
    const messagesContainer = document.getElementById('chat-messages-container');
    if (!messagesContainer) return;
    const div = document.createElement('div');
    div.className = 'chat-message bot';
    div.innerHTML = '<div class="message-bubble">' + this.escapeHtml(text) + '</div>';
    messagesContainer.appendChild(div);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
    this.saveChatMessages();
  },
  waitForConsent(callback, maxAttempts = 50) {
    const CONSENT_KEY = 'chat_consent_ne';
    let attempts = 0;
    const checkConsent = () => {
      attempts++;
      const hasConsent = localStorage.getItem(CONSENT_KEY);
      if (hasConsent) {
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(checkConsent, 200); // Check every 200ms
      } else {
        console.warn('Consent timeout - message not sent automatically');
        const msg = LOCALE === 'it' ? 'Per favore accetta il consenso al chat per inviare il tuo messaggio.' : LOCALE === 'es' ? 'Acepta el consentimiento del chat para enviar tu mensaje.' : 'Bitte akzeptiere die Chat-Einwilligung, damit deine Nachricht gesendet werden kann.';
        this.addBotMessageSimple(msg);
      }
    };
    checkConsent();
  },
  openChatWithMessage(message) {
    this.saveToSessionStorage();
    const context = this.getQuizContext();
    sessionStorage.setItem('ne-quiz-context', context);
    if (typeof window.toggleChat === 'function') {
      window.toggleChat();
      this.waitForConsent(() => {
        setTimeout(() => {
          this.addUserMessageToChat(message);
          this.showAdvancedTypingIndicator();
          this.sendQuizMessageToWebhook(message, context);
        }, 600);
      });
    } else {
      console.warn('Chatbot not available');
      alert(LOCALE === 'it' ? 'Il chatbot non è disponibile su questa pagina.' : LOCALE === 'es' ? 'El chatbot no está disponible en esta página.' : 'Der Chatbot ist auf dieser Seite nicht verfügbar.');
    }
  },
  resetQuiz() {
    this.answers = { q1: null, q2: null, q3: null, q4: null, q5: null };
    this._trackingProcessStarted = false;
    this._trackingResultsSent = false;
    document.querySelectorAll('.ne-quiz-option.selected').forEach(el => el.classList.remove('selected'));
    // Session Storage komplett clearen (Antworten + Tracking Flags)
    sessionStorage.removeItem('ne-quiz-answers');
    sessionStorage.removeItem('ne_quiz_tracking_started');
    sessionStorage.removeItem('ne_quiz_tracking_success');
    console.log('[Session Reset] Quiz session cleared (including tracking flags)');
    this.goTo(0);
  },
  sendQuickChat() {
    const input = document.getElementById('ne-quick-chat-input');
    const message = input.value.trim();
    if (!message) {
      input.focus();
      return;
    }
    const userMessage = message;
    input.value = '';
    this.saveToSessionStorage();
    const context = this.getQuizContext();
    sessionStorage.setItem('ne-quiz-context', context);
    if (typeof window.toggleChat === 'function') {
      window.toggleChat();
      this.waitForConsent(() => {
        setTimeout(() => {
          this.addUserMessageToChat(userMessage);
          this.showAdvancedTypingIndicator();
          this.sendQuizMessageToWebhook(userMessage, context);
        }, 600);
      });
    } else {
      console.warn('Chatbot not available');
      alert(LOCALE === 'it' ? 'Il chatbot non è disponibile su questa pagina.' : LOCALE === 'es' ? 'El chatbot no está disponible en esta página.' : 'Der Chatbot ist auf dieser Seite nicht verfügbar.');
    }
  },
  saveToSessionStorage() {
    sessionStorage.setItem('ne-quiz-goal', this.answers.q1);
    sessionStorage.setItem('ne-quiz-gender', this.answers.q2);
    sessionStorage.setItem('ne-quiz-age', this.answers.q3);
    sessionStorage.setItem('ne-quiz-diet', this.answers.q4);
    sessionStorage.setItem('ne-quiz-life', this.answers.q5);
  }
};
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.ne-quiz-cart-btn');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const productHandle = btn.dataset.productHandle;
  if (!productHandle) return;
  const originalHTML = btn.innerHTML;
  btn.innerHTML = '<svg viewBox="0 0 24 24" style="width:18px;height:18px;"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="60" stroke-dashoffset="15" style="animation: spin 1s linear infinite;"/></svg>';
  btn.disabled = true;
  fetch(`/products/${productHandle}.js`)
    .then(r => r.json())
    .then(data => {
      const variantId = data.variants[0].id;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId.toString(), quantity: 1 })
      });
    })
    .then(() => {
      console.log('[Quiz] Added to cart:', productHandle);
      btn.innerHTML = '<svg viewBox="0 0 24 24" style="width:18px;height:18px;stroke:currentColor;fill:none;stroke-width:2.5;margin-right:6px;flex-shrink:0;"><polyline points="20 6 9 17 4 12"/></svg>Hinzugefügt';
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      setTimeout(() => {
        const cartIcon = document.querySelector('[data-js-cart-icon]');
        if (cartIcon) cartIcon.click();
      }, 300);
      setTimeout(() => {
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      }, 2000);
    })
    .catch(err => {
      console.error('[Quiz] Add to cart error:', err);
      btn.innerHTML = '<svg viewBox="0 0 24 24" style="width:18px;height:18px;stroke:currentColor;fill:none;stroke-width:2.5;margin-right:6px;flex-shrink:0;"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>Fehler';
      setTimeout(() => {
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      }, 2000);
    });
});
NEQuiz.init();
})();